<div class="mt-3" style="display: flex;justify-content: flex-end;border-bottom: 1px solid #e9e9e9;padding-bottom: 15px;">
  <div class="roi-report float-right" *ngIf="!readOnly" style="margin-right: 25px;">
    <button type="button" class="button" style="margin-bottom: 0; white-space: nowrap;" (click)="exportToDoc()">Download Word</button>
  </div>
  <div class="pointer float-right report-custom" *ngIf="!showReportCustomize" style="padding: 0 15px;" (click)="openCustomizeReport()">
    <i class="ion-android-settings" style="margin-right: 5px;"></i>
    <span>Customize</span>
  </div>
  <div class="pointer float-right report-custom" *ngIf="showReportCustomize" style="width: 20%;padding: 0 15px;" (click)="openCustomizeReport()">
    <span>Customize Settings</span>
    <i class="ion-close-round float-right"></i>
  </div>
</div>
<div class="d-flex">
  <div #reportCustomize class="{{selectedThemeName}}" [ngStyle]="{'width': !showReportCustomize ? '100%':'80%', 'overflow-y': 'auto', 'height': 'calc(100vh - '+top_height+'px)', 'color': selectedTextColor}" id="report-page">
    <!-- New Report Design Theme 1 and Theme 2 Start -->
    <ng-template [ngIf]="(selectedThemeName === 'theme1' || selectedThemeName === 'theme2') && isReportingV2Enabled">
      <div class="row theme border intro-page-v2 d-flex align-items-center mt-3" [style.background-image]="topMainSvg">
        <div class="d-flex justify-content-start mb-3 w-100 main-page-logo">
              <div class="mt-3" [ngStyle]="logoBg"></div>
        </div>
        <div class="d-flex flex-column title-page-content">
          <h4 [ngStyle]="{'color': selectedThemeColor}" class="text mt-5 mb-4">{{clientTaxplanData.name}}</h4>
          <h1 [ngStyle]="{'color': selectedThemeColor}" class="report-title">TAX SAVINGS ANALYSIS FOR {{taxYear || ''}}</h1>
        </div>
      </div>
      <div class="row theme border index-page-v2 d-flex flex-column mt-3" [style.background-image]="selectedThemeName === 'theme1' ? contentSvg : null">
        <div class="d-flex justify-content-end mb-3">
          <div class="logo-on-strategy-page mt-3" [ngStyle]="logoBg"></div>
        </div>
        <div class="container mt-4 mb-5 pd-4 toc-container" [ngClass]="selectedThemeName">
          <h3 [ngStyle]="{'color': selectedThemeColor}" class="mb-3">Table of Contents</h3>
          
          <div class="toc-item" (click)="scrollTo('disclaimer')">
            <span class="toc-title">Disclaimer</span>
            <span class="toc-dots"></span>
            <span class="toc-page">1</span>
          </div>
        
          <div class="toc-item" (click)="scrollTo('howToRead')">
            <span class="toc-title">How to Read This Report</span>
            <span class="toc-dots"></span>
            <span class="toc-page">2</span>
          </div>
        
          <div class="toc-item" (click)="scrollTo('howToRead')">
            <span class="toc-title">Key Planning Terms</span>
            <span class="toc-dots"></span>
            <span class="toc-page">2</span>
          </div>
        
          <div class="toc-item" (click)="scrollTo('taxStrategies')">
            <span class="toc-title">Tax Savings Strategies</span>
            <span class="toc-dots"></span>
            <span class="toc-page">3</span>
          </div>
        
          <div class="toc-item" (click)="scrollTo('investmentFees')">
            <span class="toc-title">Estimated Strategy Investment </span>
            <span class="toc-dots"></span>
            <span class="toc-page">4</span>
          </div>
        
          <div class="toc-item" *ngFor="let strategy of reportData index as i" (click)="scrollTo('strategy-' + i)">
            <span class="toc-title">{{strategy.name}}</span>
            <span class="toc-dots"></span>
            <span class="toc-page">{{ 5 + i }}</span>
          </div>
        
          <div class="toc-item" (click)="scrollTo('finalNotes')">
            <span class="toc-title">Notes & Ongoing Planning</span>
            <span class="toc-dots"></span>
            <span class="toc-page"> {{ 5 + listOfStrategies.length }}</span>
          </div>

          <div class="toc-item" *ngIf="overviewStatus" (click)="scrollTo('implementation')">
            <span class="toc-title">Implementation Overview</span>
            <span class="toc-dots"></span>
            <span class="toc-page">{{ 6 + listOfStrategies.length }}</span>
          </div>
        </div>
      </div>
      <div class="row theme border index-page-v2 d-flex flex-column mt-3" [style.background-image]="selectedThemeName === 'theme1' ? contentSvg : null" id="disclaimer">
        <div class="d-flex justify-content-end mb-3">
          <div class="logo-on-strategy-page mt-3" [ngStyle]="logoBg"></div>
        </div>
        <div class="d-flex flex-column mb-5 flex-grow-1">
          <h3 [ngStyle]="{'color': selectedThemeColor}">Disclaimer</h3>
          <h4 [ngStyle]="{'color': selectedThemeColor}">Preliminary Estimate for Educational Purposes Only.</h4>
          <div class="disclaimer-section" [innerHTML]="disclaimer"></div>
        </div>
        <div class="page-footer d-flex justify-content-between align-items-center mb-3" *ngIf="selectedThemeName === 'theme2'">
          <div class="report-title">
            TAX SAVINGS ANALYSIS FOR {{ taxYear || '' }}
          </div>

          <div class="page-no">
            Page | <strong>1</strong>
          </div>
        </div>
      </div>
      <div class="row theme border index-page-v2 d-flex flex-column mt-3" [style.background-image]="selectedThemeName === 'theme1' ? contentSvg : null" id="howToRead">
        <div class="d-flex justify-content-end mb-3">
          <div class="logo-on-strategy-page mt-3" [ngStyle]="logoBg"></div>
        </div>
        <div class="p-4 flex-grow-1 mb-5">
          <h3 [ngStyle]="{'color': selectedThemeColor}">How to Read This Report</h3>
          <p>
            This report outlines tax planning strategies designed to reduce your tax liability. It includes estimated impacts, recommended actions, and timing guidance. The definitions below explain key terms used throughout the report.
          </p>
          <h3 [ngStyle]="{'color': selectedThemeColor}">Key Planning Terms</h3>
          <h4 [ngStyle]="{'color': selectedThemeColor}">Amount</h4>
          <p>
            Amount represents the value used to calculate the estimated tax impact of a strategy.
            Depending on the strategy, this amount may reflect a deduction, income shift,
            credit, or deferred income. The Amount does not necessarily represent cash paid or received.
          </p>
          <h4 [ngStyle]="{'color': selectedThemeColor}">Amount Type</h4>
          <p>Amount Type describes how a strategy impacts your taxes. Common amount types include:</p>
          <ul style="padding-left: 40px;">
            <li><b>Deduction</b> – reduces taxable income</li>
            <li><b>Shifting</b> – moves income to a lower-taxed individual or entity</li>
            <li><b>Credit</b> – directly reduces tax owed</li>
            <li><b>Deferral</b> – delays tax liability to a future year</li>
            <li><b>Exclusion</b> – permanent elimination of tax</li>
          </ul>
          <p>
            The Amount Type helps explain the mechanism through which tax savings are generated.
          </p>
          <h4 [ngStyle]="{'color': selectedThemeColor}">Estimated Savings</h4>
          <p>
            Estimated Savings reflects the projected reduction in tax liability based on current assumptions, tax rates, and timely implementation. Actual results may vary based on final execution and tax return data.
          </p>

          <h4 [ngStyle]="{'color': selectedThemeColor}">Due Date</h4>
          <p>
            Due Date represents a highly recommended timeframe for completing actions related to a strategy. Meeting the Due Date helps ensure the strategy can be implemented as intended. Delays may impact eligibility, timing, or the amount of potential tax savings.
          </p>

          <h4 [ngStyle]="{'color': selectedThemeColor}">Estimated Strategy Investment</h4>
          <p>
            Estimated Strategy Investment reflects whether a strategy requires new cash, reallocates existing cash, or does not require additional cash out of pocket. When applicable, this amount represents the estimated cash required to implement the strategy.
          </p>

          <h4 [ngStyle]="{'color': selectedThemeColor}">Third-Party Fees</h4>
          <p>
            Third-Party Fees are estimated costs paid to external providers such as engineers, attorneys, or investment sponsors required to implement certain strategies.
          </p>
        </div>
          <div class="page-footer d-flex justify-content-between align-items-center mb-3" *ngIf="selectedThemeName === 'theme2'">
          <div class="report-title">
            TAX SAVINGS ANALYSIS FOR {{ taxYear || '' }}
          </div>

          <div class="page-no">
            Page | <strong>2</strong>
          </div>
        </div>
      </div>
      <div class="row theme border index-page-v2 d-flex flex-column mt-3" [style.background-image]="selectedThemeName === 'theme1' ? contentSvg : null" id="taxStrategies">
        <div class="d-flex justify-content-end mb-3">
          <div class="logo-on-strategy-page mt-3" [ngStyle]="logoBg"></div>
        </div>
        <div class="d-flex flex-column">
          <h3 [ngStyle]="{'color': selectedThemeColor}">Tax Savings Strategies</h3>
        </div>
        <h4 [ngStyle]="{'color': selectedThemeColor}">Strategy Impact Overview</h4>
        <p>This section summarizes the tax strategies included in your plan and how each contributes to your overall estimated tax savings. Detailed explanations and next steps for each strategy are provided in the sections that follow.</p>
        <h4 [ngStyle]="{'color': selectedThemeColor}">Tax Savings Summary</h4>
        <div class="d-flex flex-column mt-2 mb-5">
          <table class="table table-bordered text-center table-striped theme-table" [style.--text-color]="selectedTextColor">
            <thead [style.--secondry-theme-color]="selectedThemeSecColor">
              <tr>
                <th class="text-start fs-6 p-3">Strategy</th>
                <th class="text-start fs-6 p-3">Related Party</th>
                <th class="text-start fs-6 p-3">Amount</th>
                <th class="text-start fs-6 p-3">Amount Type</th>
                <th class="text-start fs-6 p-3">Estimated Savings</th>
              </tr>
            </thead>

            <tbody>
              <tr *ngFor="let strategy of reportData">
                <td class="text-start fs-6 p-3">{{ strategy.name }}</td>
                <td class="text-start fs-6 p-3">{{ strategy.relatedParty }}</td>
                <td class="text-start fs-6 p-3">{{ strategy.planAmount | formatAmount:'$0,0' }}</td>
                <td class="text-start fs-6 p-3">{{ strategy.amountType }}</td>
                <td class="text-start fs-6 p-3">{{strategy.estimatedSavings | formatAmount:'$0,0'}}</td>
              </tr>
              <tr class="fw-bold table-light total-row" [style.--primary-theme-color]="selectedThemeColor" >
              <td colspan="3"></td>
              <td class="text-start fs-6 p-3 total-highlight">Total Savings</td>
              <td class="text-start fs-6 p-3 total-highlight">{{ totalSavings | formatAmount:'$0,0' }}</td>
            </tr>
            </tbody>
          </table>
          <hr  [ngStyle]="{'border-top': '0px solid ' + selectedTextColor,'margin': '50px 0'}">
        </div>
        <div class="d-flex flex-wrap mt-5 mb-5" *ngIf="listOfStrategies.length === 0">
          No strategies available.
        </div>
        <div class="page-footer d-flex justify-content-between align-items-center mb-3" *ngIf="selectedThemeName === 'theme2'">
          <div class="report-title">
            TAX SAVINGS ANALYSIS FOR {{ taxYear || '' }}
          </div>

          <div class="page-no">
            Page | <strong>3</strong>
          </div>
        </div>
      </div>
      <div class="row theme border index-page-v2 d-flex flex-column mt-3" [style.background-image]="selectedThemeName === 'theme1' ? contentSvg : null" id="investmentFees">
        <div class="d-flex justify-content-end mb-3">
          <div class="logo-on-strategy-page mt-3" [ngStyle]="logoBg"></div>
        </div>
        <div class="d-flex flex-column">
          <h3 [ngStyle]="{'color': selectedThemeColor}">Estimated Strategy Investment </h3>
        </div>
        <p>This section summarizes whether any additional cash is required to implement the strategies included in your tax plan. Many strategies reduce taxes without requiring new cash out of pocket. Some strategies may involve an investment of capital that continues to grow over time. Where applicable, estimated third-party fees are shown separately.</p>
        <div class="d-flex flex-column mt-2 mb-5" *ngIf="listOfStrategies.length > 0">
          <table class="table table-bordered text-center table-striped theme-table" [style.--text-color]="selectedTextColor">
            <thead [style.--secondry-theme-color]="selectedThemeSecColor">
              <tr>
                <th class="text-start fs-6 p-3">Strategy</th>
                <th class="text-start fs-6 p-3">Related Party</th>
                <th class="text-start fs-6 p-3">Estimated Strategy Investment</th>
              </tr>
            </thead>

            <tbody>
              <tr *ngFor="let strategy of reportData">
                <td class="text-start fs-6 p-3">{{ strategy.name }}</td>
                <td class="text-start fs-6 p-3">{{ strategy.relatedParty }}</td>
                <td class="text-start fs-6 p-3">{{
                strategy.investedAmount === 0.0
                  ? 'No Strategy Investment Required'
                  : (strategy.investedAmount | formatAmount:'$0,0')
              }}</td>
              </tr>
              <!-- <tr>
                <td class="text-start fs-6 p-3">Third Party Fees</td>
                <td class="text-start fs-6 p-3"></td>
                <td class="text-start fs-6 p-3">-{{totalThirdPartyFees | formatAmount:'$0,0'}}</td>
              </tr> -->
              <tr class="fw-bold table-light total-row" [style.--primary-theme-color]="selectedThemeColor">
              <td colspan="1"></td>
              <td class="text-start fs-6 p-3 total-highlight">Total Strategy Investment</td>
              <td class="text-start fs-6 p-3 total-highlight">{{totalInvestedAmount | formatAmount:'$0,0'}}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="d-flex flex-wrap mt-5 mb-5" *ngIf="listOfStrategies.length === 0">
          No strategies available.
        </div>
        <div class="page-footer d-flex justify-content-between align-items-center mb-3" *ngIf="selectedThemeName === 'theme2'">
          <div class="report-title">
            TAX SAVINGS ANALYSIS FOR {{ taxYear || '' }}
          </div>

          <div class="page-no">
            Page | <strong>4</strong>
          </div>
        </div>
      </div>
      <div  class="row theme border data-page-v2 d-flex flex-column mt-3"  [style.background-image]="selectedThemeName === 'theme1' ? contentSvg : null" *ngFor="let strategy of reportData; index as i"  [id]="'strategy-' + i">
        <div class="strategy-info d-flex flex-column">
          <div class="d-flex justify-content-end mb-3">
            <div class="logo-on-strategy-page" [ngStyle]="logoBg"></div>
          </div>
          <h3 [ngStyle]="{'color': selectedThemeColor}">{{strategy.name}}</h3>
          <table class="table table-bordered theme-table">
            <tbody [style.--secondry-theme-color]="selectedThemeSecColor">
              <tr>
                <th class="text-start">Tax Category</th>
                <td class="text-end">{{strategy.category}}</td>
              </tr>
      
              <tr>
                <th class="text-start">Related Party</th>
                <td class="text-end">{{strategy.relatedParty}}</td>
              </tr>
      
              <tr>
                <th class="text-start">Amount (deduction or credit)</th>
                <td class="text-end">{{strategy.planAmount | formatAmount:'$0,0'}}</td>
              </tr>
      
              <tr>
                <th class="text-start">Estimated Strategy Investment</th>
                <td class="text-end">{{ strategy?.investedAmount > 0 ? (strategy.investedAmount | formatAmount:'$0,0') : 'No Strategy Investment Required' }}</td>
              </tr>
      
              <tr>
                <th class="text-start">Estimated Federal Tax Savings</th>
                <td class="text-end">{{strategy.taxSavings | formatAmount:'$0,0'}}</td>
              </tr>
      
              <tr>
                <th class="text-start">Estimated State Tax Savings</th>
                <td class="text-end">{{strategy.stateTaxSavings | formatAmount:'$0,0'}}</td>
              </tr>
            </tbody>
          </table>
          <div class="client-overview mt-3">
            <h4 [ngStyle]="{'color': selectedThemeColor}">What This Strategy Is</h4>
            <div *ngIf="strategy.clientOverview" class="text report-strategy-content mt-2 word-wrap" #clientoverview id="overview-{{strategy.id}}"  [innerHTML]="strategy.clientOverview"></div>
            <div *ngIf="!strategy.clientOverview" class="text report-strategy-content mt-2 mb-2">No data available.</div>
          </div>
          <div class="client-overview mt-3 mb-3">
            <h4 [ngStyle]="{'color': selectedThemeColor}">Why This Applies to You</h4>
            <div *ngIf="strategy.reportCustomText" class="text report-strategy-content mt-2 word-wrap"
              [innerHTML]="strategy.reportCustomText"></div>
            <div *ngIf="!strategy.reportCustomText" class="text report-strategy-content mt-2 mb-2">No data
              available.</div>
          </div>
          <!-- <div class="client-overview mt-3 mb-3">
            <h4 [ngStyle]="{'color': selectedThemeColor}">Investment & Third-Party Fees</h4>
            <div class="text report-strategy-content mt-2 word-wrap">
              <p>This strategy does not require additional cash out of pocket to generate the tax benefit. Depreciation deductions are accelerated based on the existing cost of the property.</p>
              <p>A third-party cost segregation study is required. Estimated fees for this service are shown above and may vary based on property size and complexity.</p>
            </div>
          </div> -->
          <div>
            <h4 [ngStyle]="{'color': selectedThemeColor}">Eligibility Considerations</h4>
            <div class="text mt-2" *ngIf="strategy.criteria && strategy.criteria.length > 0">
              <ul>
                <li class="word-wrap" *ngFor="let criteria of strategy.criteria">{{criteria.text}}</li>
              </ul>
            </div>
            <div class="text mt-2 mb-2" *ngIf="strategy.criteria && strategy.criteria.length === 0">
              No data available.
            </div>
          </div>
          <!-- <div>
            <h4 [ngStyle]="{'color': selectedThemeColor}">Opportunities</h4>
            <div class="text mt-2" *ngIf="strategy.opportunities && strategy.opportunities.length > 0">
              <ul>
                <li class="word-wrap" *ngFor="let opportunity of strategy.opportunities">{{opportunity.description}}</li>
              </ul>
            </div>
            <div class="text mt-2 mb-2" *ngIf="strategy.opportunities && strategy.opportunities.length === 0">
              No data available.
            </div>
          </div>
          <div>
            <h4 [ngStyle]="{'color': selectedThemeColor}">Risks</h4>
            <div class="text mt-2" *ngIf="strategy.potentialRisks && strategy.potentialRisks.length > 0">
              <ul>
                <li class="word-wrap" *ngFor="let risk of strategy.potentialRisks">{{risk.description}}</li>
              </ul>
            </div>
            <div class="text mt-2 mb-2" *ngIf="strategy.potentialRisks && strategy.potentialRisks.length === 0">
              No data available.
            </div>
          </div> -->
          <div>
            <h4 [ngStyle]="{'color': selectedThemeColor}">Client Education & Resources</h4>
            <div *ngIf="strategy.clientResources" class="text report-strategy-content mt-2 word-wrap" #clientresources
              id="resource-{{strategy.id}}" [innerHTML]="strategy.clientResources"></div>
            <div *ngIf="!strategy.clientResources" class="text report-strategy-content mt-2 mb-2">No data available.</div>
          </div>
        
          <div *ngIf="todoTaskStatus">
            <h4 [ngStyle]="{'color': selectedThemeColor}">Client Responsibilities</h4>
            <table class="table table-bordered text-center table-striped theme-table" [style.--text-color]="selectedTextColor">
            <thead [style.--secondry-theme-color]="selectedThemeSecColor">
              <tr>
                <th class="text-start fs-6 p-3">ToDo</th>
                <th class="text-start fs-6 p-3">Due Date</th>
              </tr>
            </thead>
            <tbody *ngIf="strategy.toDoDetails?.length > 0">
              <tr *ngFor="let item of strategy.toDoDetails">
                <td class="text-start fs-6 p-3">{{ item.name }}</td>
                <td class="text-start fs-6 p-3">{{ item.dueDate }}</td>
              </tr>
            </tbody>
            <tbody  *ngIf="!strategy.toDoDetails || strategy.toDoDetails.length === 0">
              <tr>
                <td class="text-start fs-6 p-3">No Data is available</td>
                <td class="text-start fs-6 p-3"></td>
              </tr>
            </tbody>
          </table>
          </div>
          <div class="mb-3" *ngIf="todoTaskStatus">
              <h4 [ngStyle]="{'color': selectedThemeColor}">{{clientTaxplanData.firmName}} Tax Advisors Responsibilities</h4>
              <table class="table table-bordered text-center table-striped theme-table" [style.--text-color]="selectedTextColor">
              <thead [style.--secondry-theme-color]="selectedThemeSecColor">
                <tr>
                  <th class="text-start fs-6 p-3">Task</th>
                  <th class="text-start fs-6 p-3">Due Date</th>
                </tr>
              </thead>
              <tbody *ngIf="strategy.taskDetails?.length > 0">
                <tr *ngFor="let item of strategy.taskDetails">
                  <td class="text-start fs-6 p-3">{{ item.title }}</td>
                  <td class="text-start fs-6 p-3">{{ item.dueDate }}</td>
                </tr>
              </tbody>
              <tbody  *ngIf="!strategy.taskDetails || strategy.taskDetails.length === 0">
              <tr>
                <td class="text-start fs-6 p-3">No Data is available</td>
                <td class="text-start fs-6 p-3"></td>
              </tr>
            </tbody>
            </table>
          </div>
        </div>
        <div class="page-footer d-flex justify-content-between align-items-center mb-3 mt-5" *ngIf="selectedThemeName === 'theme2'">
          <div class="report-title">
            TAX SAVINGS ANALYSIS FOR {{ taxYear || '' }}
          </div>

          <div class="page-no">
            Page | <strong>{{ 5 + i }}</strong>
          </div>
        </div>
      </div>
      <div class="row theme border index-page-v2 d-flex flex-column mt-3" [style.background-image]="selectedThemeName === 'theme1' ? contentSvg : null" id="finalNotes">
        <div class="mb-3">
            <h3 [ngStyle]="{'color': selectedThemeColor}">Notes & Ongoing Planning</h3>
            <p>Tax planning is an ongoing process. The strategies outlined in this report are based on current information, assumptions, and tax law. As your financial situation changes—or as tax laws and interpretations evolve—your tax plan should be reviewed and updated accordingly.</p>
              <p>Some strategies included in this plan may span multiple years or require coordination with third-party providers. Others may become more or less applicable over time. Regular review helps ensure your tax plan continues to align with your goals and maximizes potential benefits.</p>
            <p>If you have questions about this report or next steps, please contact {{clientTaxplanData.firmName}} Tax Advisors before taking action.</p>
            <h4 [ngStyle]="{'color': selectedThemeColor}">What Happens Next</h4>
            <ul style="padding-left: 40px;">
            <li *ngIf="overviewStatus">Complete any outstanding action items shown in the <b>Implementation Overview</b></li>
            <li>Coordinate with your tax professional as tasks are completed</li>
            <li>Revisit this plan prior to major financial decisions or annually as part of your tax planning process</li>
          </ul>
          </div>
          <div class="page-footer d-flex justify-content-between align-items-center mb-3 mt-5" *ngIf="selectedThemeName === 'theme2'">
          <div class="report-title">
            TAX SAVINGS ANALYSIS FOR {{ taxYear || '' }}
          </div>

          <div class="page-no">
            Page | <strong>{{ 5 + listOfStrategies.length }}</strong>
          </div>
        </div>
          </div>
      <div class="row theme border index-page-v2 d-flex flex-column mt-3" *ngIf="overviewStatus" [style.background-image]="selectedThemeName === 'theme1' ? contentSvg : null" id="implementation">
        <div class="d-flex flex-column mb-5">
          <h3 [ngStyle]="{'color': selectedThemeColor}">Implementation Overview</h3>
          <p>
            This page provides a high-level view of the actions that will be required to implement your tax plan. You do not need to complete these items immediately. Detailed explanations for each action are provided in the strategy sections that follow.
          </p>
          <div>
            <h4 [ngStyle]="{'color': selectedThemeColor}">Client Action Items</h4>
            <table class="table table-bordered text-center table-striped theme-table" [style.--text-color]="selectedTextColor" *ngIf="allToDoDetails && allToDoDetails.length  > 0">
            <thead [style.--secondry-theme-color]="selectedThemeSecColor">
              <tr>
                <th class="text-start fs-6 p-3">ToDo</th>
                <th class="text-start fs-6 p-3">Strategy</th>
                <th class="text-start fs-6 p-3">Due Date</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of allToDoDetails">
                <td class="text-start fs-6 p-3">{{ item.name }}</td>
                <td class="text-start fs-6 p-3">{{ item.strategyName }}</td>
                <td class="text-start fs-6 p-3">{{ item.dueDate }}</td>
              </tr>
            </tbody>
          </table>
            <div class="text mt-2 mb-2" *ngIf="allToDoDetails && allToDoDetails.length === 0">
              No data available.
            </div>
          </div>
          <div class="mb-3">
              <h4 [ngStyle]="{'color': selectedThemeColor}">{{clientTaxplanData.firmName}} Tax Action Items</h4>
              <table class="table table-bordered text-center table-striped theme-table" [style.--text-color]="selectedTextColor" *ngIf="allTaskDetails && allTaskDetails.length > 0">
              <thead [style.--secondry-theme-color]="selectedThemeSecColor">
                <tr>
                  <th class="text-start fs-6 p-3">Task</th>
                  <th class="text-start fs-6 p-3">Strategy</th>
                  <th class="text-start fs-6 p-3">Due Date</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of allTaskDetails">
                  <td class="text-start fs-6 p-3">{{ item.title }}</td>
                  <td class="text-start fs-6 p-3">{{ item.strategyName }}</td>
                  <td class="text-start fs-6 p-3">{{ item.dueDate }}</td>
                </tr>
              </tbody>
            </table>
              <div class="text mt-2 mb-2" *ngIf="allTaskDetails && allTaskDetails.length === 0">
                No data available.
              </div>
          </div>
          <h4 [ngStyle]="{'color': selectedThemeColor}">Important Timing Note</h4>
          <p>Some strategies depend on timely implementation. Completing action items within the recommended timeframes helps preserve strategy eligibility and projected tax savings. Certain strategies cannot be implemented retroactively.</p>
        </div>
        <div class="page-footer d-flex justify-content-between align-items-center mb-3" *ngIf="selectedThemeName === 'theme2'">
          <div class="report-title">
            TAX SAVINGS ANALYSIS FOR {{ taxYear || '' }}
          </div>

          <div class="page-no">
            Page | <strong>{{ 6 + listOfStrategies.length }}</strong>
          </div>
        </div>
      </div>
    </ng-template>
    <ng-template [ngIf]="selectedThemeName === 'theme3' && isReportingV2Enabled">
      <div class="row theme border intro-page-v2 d-flex mt-3" [ngStyle]="{
       'background': 'linear-gradient(0deg, ' 
         + hexToRgba(selectedThemeColor, 0.1) + ' 30%, ' 
         + selectedThemeColor + ' 25%)'
     }">
        <div class="d-flex flex-column title-page-content mt-5">
          <h4 [ngStyle]="{'color': '#ffffff'}" class="text mt-5 mb-4">{{clientTaxplanData.name}}</h4>
          <h1 [ngStyle]="{'color': '#ffffff'}" class="report-title">TAX SAVINGS ANALYSIS FOR {{taxYear || ''}}</h1>
        </div>
        <div class="d-flex justify-content-end mt-auto mb-3">
          <div class="logo-on-strategy-page" [ngStyle]="logoBg"></div>
        </div>
      </div>
      <div class="row theme border index-page-v2 d-flex flex-column mt-3" [style.background-image]="selectedThemeName === 'theme1' ? contentSvg : null">
        <div class="d-flex justify-content-end mb-3">
          <div class="logo-on-strategy-page mt-3" [ngStyle]="logoBg"></div>
        </div>
        <div class="container mt-4 mb-5 pd-4 toc-container" [ngClass]="selectedThemeName">
          <h3 [ngStyle]="{'color': selectedThemeColor}" class="mb-3">Table of Contents</h3>
          
          <div class="toc-item" (click)="scrollTo('disclaimer')">
            <span class="toc-title">Disclaimer</span>
            <span class="toc-dots"></span>
            <span class="toc-page">1</span>
          </div>
        
          <div class="toc-item" (click)="scrollTo('howToRead')">
            <span class="toc-title">How to Read This Report</span>
            <span class="toc-dots"></span>
            <span class="toc-page">2</span>
          </div>
        
          <div class="toc-item" (click)="scrollTo('howToRead')">
            <span class="toc-title">Key Planning Terms</span>
            <span class="toc-dots"></span>
            <span class="toc-page">2</span>
          </div>
        
          <div class="toc-item" (click)="scrollTo('taxStrategies')">
            <span class="toc-title">Tax Savings Strategies</span>
            <span class="toc-dots"></span>
            <span class="toc-page">3</span>
          </div>
        
          <div class="toc-item" (click)="scrollTo('investmentFees')">
            <span class="toc-title">Estimated Strategy Investment </span>
            <span class="toc-dots"></span>
            <span class="toc-page">4</span>
          </div>
        
          <div class="toc-item" *ngFor="let strategy of reportData index as i" (click)="scrollTo('strategy-' + i)">
            <span class="toc-title">{{strategy.name}}</span>
            <span class="toc-dots"></span>
            <span class="toc-page">{{ 5 + i }}</span>
          </div>
        
          <div class="toc-item" (click)="scrollTo('finalNotes')">
            <span class="toc-title">Notes & Ongoing Planning</span>
            <span class="toc-dots"></span>
            <span class="toc-page"> {{ 5 + listOfStrategies.length }}</span>
          </div>

          <div class="toc-item" *ngIf="overviewStatus" (click)="scrollTo('implementation')">
            <span class="toc-title">Implementation Overview</span>
            <span class="toc-dots"></span>
            <span class="toc-page">{{ 6 + listOfStrategies.length }}</span>
          </div>
        </div>
      </div>
      <div class="row theme border index-page-v2 d-flex flex-column mt-3" id="disclaimer" [ngStyle]="{
  'background': hexToRgba(selectedThemeColor, 0.02)}">
        <div class="d-flex flex-column mb-5 flex-grow-1">
          <h3 [ngStyle]="{'color': selectedThemeColor}">Disclaimer</h3>
          <h4 [ngStyle]="{'color': selectedThemeColor}">Preliminary Estimate for Educational Purposes Only.</h4>
          <div [ngStyle]="{'color': selectedTextColor}" [innerHTML]="disclaimer"></div>
        </div>
        <div class="page-footer d-flex justify-content-end align-items-center mt-5">
         <div class="page-no">
            Page | <strong>1</strong>
          </div>
        </div>
      </div>
      <div class="row theme border index-page-v2 d-flex flex-column mt-3" [style.background-image]="contentSvg" id="howToRead">
        <div class="p-4 mb-5">
          <h3 [ngStyle]="{'color': selectedThemeColor}">How to Read This Report</h3>
          <p>
            This report outlines tax planning strategies designed to reduce your tax liability. It includes estimated impacts, recommended actions, and timing guidance. The definitions below explain key terms used throughout the report.
          </p>
          <h3 [ngStyle]="{'color': selectedThemeColor}">Key Planning Terms</h3>
          <h4 [ngStyle]="{'color': selectedThemeColor}">Amount</h4>
          <p>
            Amount represents the value used to calculate the estimated tax impact of a strategy.
            Depending on the strategy, this amount may reflect a deduction, income shift,
            credit, or deferred income. The Amount does not necessarily represent cash paid or received.
          </p>
          <div class="tax-box p-3 mb-4">
          <h5 class="p-2 rounded-2" [ngStyle]="{'color': '#ffffff', 'background-color':selectedThemeColor }">Amount Type</h5>
          <p>Amount Type describes how a strategy impacts your taxes. Common amount types include:</p>
          
          
            <div class="tax-item">
              <!-- ICON -->
              <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="60" height="60" x="0" y="0" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M416.864 221.647c-16.525-24.679-34.577-43.554-52.05-55.033a38.066 38.066 0 0 0 6.281-20.979c0-15.645-9.433-29.12-22.906-35.06l14.202-37.044c2.222-5.797 8.983-23.441-1.12-36.618-10.162-13.253-28.386-11.361-41.695-9.979-3.13.325-6.086.632-8.161.661-10.029.127-15.799-3.676-23.102-8.501C280.817 14.139 271.528 8 258.298 8c-.188 0-.378.002-.567.004-13.529-.188-23.001 6.067-30.611 11.093-7.304 4.825-13.098 8.645-23.096 8.499-2.08-.029-5.036-.336-8.166-.661-13.31-1.382-31.533-3.274-41.695 9.979-10.104 13.176-3.342 30.82-1.119 36.619l14.201 37.043c-13.472 5.94-22.905 19.415-22.905 35.059a38.06 38.06 0 0 0 5.299 19.405c-18.232 11.284-37.208 30.763-54.509 56.607-28.814 43.04-45.34 92.452-45.34 135.569 0 42.766 16.195 78.591 46.835 103.602 35.104 28.655 88.726 43.184 159.377 43.184s124.271-14.529 159.375-43.182c30.64-25.01 46.835-60.834 46.835-103.599 0-43.119-16.528-92.533-45.347-135.573zM192.759 56.774c3.817.396 7.423.771 10.853.819 19.26.275 31.273-7.671 40.042-13.463 6.228-4.113 9.463-6.129 13.522-6.129.084 0 .168 0 .252.002l.303.006.304-.006c4.163-.07 7.395 1.927 13.738 6.119 8.769 5.795 20.756 13.723 40.055 13.471 3.424-.048 7.029-.422 10.847-.819 3.719-.386 9.935-1.031 13.74-.776-.273 1.484-.848 3.693-2.036 6.796l-17.075 44.54H198.13l-17.074-44.539c-1.189-3.104-1.764-5.313-2.037-6.797 3.81-.257 10.022.39 13.74.776zm-10.119 97.162c-4.499 0-8.301-3.801-8.301-8.301s3.802-8.301 8.301-8.301h150.153c4.5 0 8.302 3.801 8.302 8.301s-3.802 8.301-8.302 8.301zm213.766 283.642C366.798 461.746 319.558 474 256.002 474s-110.798-12.255-140.406-36.424c-23.759-19.394-35.806-46.431-35.806-80.361 0-36.775 15.054-81.216 40.269-118.879 23.91-35.714 49.824-54.4 63.064-54.4h145.73c13.247 0 39.169 18.687 63.084 54.403 25.219 37.664 40.274 82.105 40.274 118.881 0 33.928-12.047 60.965-35.806 80.358zm-84.703-159.321-87.194 119.114a14.981 14.981 0 0 1-12.115 6.141c-3.075 0-6.178-.942-8.849-2.897-6.685-4.893-8.137-14.279-3.243-20.964l87.194-119.114c4.894-6.685 14.281-8.136 20.964-3.243 6.685 4.893 8.137 14.279 3.243 20.964zm-5.584 42.471c-19.524 0-35.409 15.897-35.409 35.438V368.1c0 19.525 15.885 35.41 35.409 35.41s35.438-15.885 35.438-35.41v-11.934c0-19.541-15.897-35.438-35.438-35.438zm5.438 47.372c0 2.932-2.49 5.41-5.438 5.41-2.932 0-5.409-2.478-5.409-5.41v-11.934c0-2.948 2.478-5.438 5.409-5.438 2.948 0 5.438 2.49 5.438 5.438zm-70.263-66.332v-11.934c0-19.541-15.897-35.438-35.438-35.438s-35.438 15.897-35.438 35.438v11.934c0 19.541 15.897 35.438 35.438 35.438s35.438-15.898 35.438-35.438zm-40.876 0v-11.934c0-2.948 2.49-5.438 5.438-5.438s5.438 2.49 5.438 5.438v11.934c0 2.948-2.49 5.438-5.438 5.438s-5.438-2.49-5.438-5.438z" fill="#5276E4" opacity="1" data-original="#000000" class=""></path></g></svg>
              <!-- TEXT -->
              <div class="content">
                <div class="title" [ngStyle]="{'color': selectedThemeColor}">Deduction</div>
                <div class="desc">reduces taxable income</div>
              </div>
            </div>
          
            <div class="tax-item">
              <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="60" height="60" x="0" y="0" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M437.691 84.12c-22.807-5.791-52.963-8.98-84.916-8.98-31.955 0-62.111 3.189-84.918 8.98-28.056 7.124-41.693 17.144-41.693 30.631v72.46h.002c-19.388-2.942-42.007-4.524-65.624-4.524-31.879 0-61.957 2.877-84.694 8.101-28.205 6.479-41.915 15.864-41.915 28.689v41.088c0 12.09 12.188 21.121 37.21 27.545v38.379c0 1.539.203 3.027.599 4.468v-.001c-26.317 6.452-39.126 15.633-39.126 28.027v41.088c0 12.824 13.711 22.209 41.915 28.689 22.737 5.224 52.816 8.101 84.695 8.101s61.957-2.877 84.695-8.101c28.204-6.48 41.915-15.864 41.915-28.689v-29.506c19.693 3.386 42.801 5.209 66.939 5.209 31.953 0 62.109-3.189 84.916-8.98 28.055-7.125 41.693-17.145 41.693-30.631V114.751c.001-13.487-13.638-23.507-41.693-30.631zm-160.334 18.287c20.672-4.687 47.457-7.268 75.418-7.268s54.744 2.581 75.416 7.268c22.205 5.033 28.971 10.443 30.75 12.344-1.779 1.9-8.545 7.31-30.75 12.344-20.672 4.687-47.455 7.267-75.416 7.267s-54.746-2.58-75.418-7.267c-22.206-5.034-28.971-10.443-30.751-12.344 1.781-1.9 8.545-7.311 30.751-12.344zM85.982 209.066c20.576-4.114 47.056-6.38 74.56-6.38 27.505 0 53.983 2.266 74.56 6.38 18.61 3.722 27.445 7.973 30.811 10.41-3.365 2.438-12.2 6.689-30.81 10.411-20.576 4.114-47.056 6.38-74.561 6.38-27.504 0-53.983-2.266-74.56-6.38-18.609-3.722-27.443-7.973-30.81-10.411 3.367-2.437 12.201-6.688 30.81-10.41zm-32.049 50.449v-18.162c5.953 2.556 13.246 4.823 21.915 6.814 22.737 5.224 52.815 8.101 84.694 8.101s61.958-2.877 84.695-8.101c8.668-1.991 15.962-4.259 21.915-6.814v18.161c-1.951 2.068-10.363 7.125-32.051 11.461-20.576 4.114-47.055 6.381-74.56 6.381-27.504 0-53.983-2.267-74.56-6.381-21.685-4.336-30.096-9.393-32.048-11.46zm249.19 25.886c-3.365 2.438-12.199 6.688-30.811 10.41-20.576 4.114-47.055 6.38-74.56 6.38-26.878 0-52.761-2.168-73.128-6.106l-.189-.015c11.547.842 23.686 1.285 36.106 1.285 31.879 0 61.958-2.877 84.695-8.102 15.11-3.471 26.056-7.777 32.968-12.999l-.006.004c14.63 3.385 21.937 6.978 24.925 9.143zM84.666 348.572c1.589-.317 3.225-.621 4.883-.916h-.001.001c6.228 2.848 14.049 5.35 23.509 7.522 22.737 5.224 52.816 8.101 84.695 8.101 23.912 0 46.811-1.619 66.358-4.633.172.115.336.229.484.336-3.367 2.438-12.2 6.689-30.811 10.41-20.576 4.114-47.056 6.381-74.56 6.381-27.505 0-53.983-2.267-74.56-6.381-18.61-3.721-27.443-7.972-30.81-10.41 3.369-2.437 12.202-6.689 30.812-10.41zm181.17 50.448c-1.953 2.068-10.363 7.124-32.051 11.461-20.576 4.113-47.056 6.38-74.56 6.38-27.505 0-53.983-2.267-74.56-6.38-21.688-4.337-30.098-9.393-32.051-11.461v-18.162c5.953 2.557 13.247 4.823 21.915 6.814 22.737 5.225 52.816 8.102 84.695 8.102s61.957-2.877 84.695-8.102c8.668-1.991 15.962-4.258 21.915-6.814v18.162zm6.477-62.122c-20.576 4.115-47.056 6.381-74.56 6.381-27.505 0-53.983-2.266-74.56-6.381-21.688-4.336-30.098-9.393-32.051-11.459v-18.162c5.953 2.556 13.247 4.822 21.915 6.814 22.737 5.223 52.816 8.1 84.695 8.1s61.958-2.877 84.696-8.1c8.668-1.992 15.961-4.259 21.914-6.814v18.162c-1.952 2.067-10.362 7.124-32.049 11.459zm187.072-1.26c-.826 1.125-6.33 7.232-31.193 12.868-20.672 4.687-47.455 7.268-75.416 7.268-20.531 0-40.416-1.396-57.723-3.991 17.188-5.438 26.697-12.476 28.836-21.32 9.35.59 19.031.896 28.887.896 31.953 0 62.109-3.189 84.916-8.98 8.572-2.178 15.791-4.625 21.693-7.359zm0-44.888v.472c-.826 1.125-6.33 7.232-31.193 12.868-20.672 4.687-47.455 7.268-75.416 7.268-9.684 0-19.217-.316-28.412-.916v-24.369c9.203.57 18.723.868 28.412.868 31.953 0 62.109-3.189 84.916-8.979 8.572-2.178 15.791-4.625 21.693-7.359zm0-44.417v.473c-.826 1.125-6.33 7.231-31.193 12.868-20.672 4.686-47.455 7.267-75.416 7.267-16.178 0-31.951-.868-46.385-2.505-5.246-2.44-11.648-4.631-19.238-6.579v-17.658c19.404 3.244 42.018 4.989 65.623 4.989 31.953 0 62.109-3.189 84.916-8.98 8.572-2.177 15.791-4.625 21.693-7.358zm0-44.416v3.135c-.826 1.125-6.33 7.232-31.193 12.869-20.672 4.686-47.455 7.267-75.416 7.267-23.734 0-46.604-1.865-65.623-5.294v-.417c0-12.683-13.416-21.998-40.988-28.47v-7.571c5.902 2.733 13.121 5.182 21.693 7.358 22.807 5.791 52.963 8.98 84.918 8.98 31.953 0 62.111-3.189 84.916-8.98 8.572-2.177 15.791-4.625 21.693-7.358zm0-42.278c-.826 1.125-6.33 7.232-31.193 12.869-20.672 4.686-47.455 7.267-75.416 7.267-27.963 0-54.746-2.581-75.418-7.267-24.863-5.637-30.368-11.744-31.193-12.869v-21.616c5.902 2.733 13.121 5.182 21.693 7.358 22.807 5.791 52.963 8.98 84.918 8.98 31.953 0 62.109-3.189 84.916-8.98 8.572-2.176 15.791-4.625 21.693-7.358z" fill="#5276E4" opacity="1" data-original="#000000" class=""></path></g></svg>
              <div class="content">
                <div class="title" [ngStyle]="{'color': selectedThemeColor}">Shifting</div>
                <div class="desc">moves income to a lower-taxed individual or entity</div>
              </div>
            </div>
          
            <div class="tax-item">
              <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="60" height="60" x="0" y="0" viewBox="0 0 1024 1024" style="enable-background:new 0 0 512 512" xml:space="preserve" class="hovered-paths"><g><path d="M932.1 252.2v521.1c0 .7-.1 1.4-.1 2.1 0 2.2.2-1.8.3-1.9-.6.8-.6 2.9-.9 3.9-.2.6-.5 1.3-.6 1.9-.4 2.3.6-2 .8-1.7.3.4-1.8 3.6-2.1 4.1-.4.7-2.2 4.4-1 1.8 1.1-2.3-.6.6-1.4 1.4-.9.9-2 1.7-2.9 2.7-1.5 1.6 1.4-1.4 1.5-1.1 0 .1-2 1.3-2.2 1.4-1.1.7-2.3 1.3-3.4 1.9-3.2 1.7 3.4-1-.1 0-1.3.4-2.6.7-3.9 1-.6.2-2.9.4 0 .1 3.5-.3-1.1 0-1.4 0H129.9c-6.2 0-12.4.1-18.6 0H110.5c-.7 0-1.4-.1-2.1-.1-2.9-.1.5-.3 1.3.2-.8-.6-2.9-.6-3.9-.9-.6-.2-1.3-.5-1.9-.6-2.3-.4 2 .6 1.7.8s-3.1-1.6-3.5-1.8c-.8-.5-4.9-2.5-2.3-1.3 2.3 1.1-.6-.6-1.4-1.4-.9-.9-1.7-2-2.7-2.9-1.6-1.5 1.4 1.4 1.1 1.5-.1 0-1-1.5-1.1-1.6-.8-1.3-1.5-2.6-2.3-4-1.7-3.2 1 3.4 0-.1-.4-1.3-.7-2.6-1-3.9-.9-3.6 0 3.7-.1-.1 0-.9-.1-1.9-.1-2.8V253.5c0-1.6.1-3.2.2-4.7 0-2.3-.1 2-.3 1.9-.1 0 .6-2.8.6-2.6.1-.3 1-3.8 1.2-3.8s-1.9 3.7-.7 1.7l.9-1.8c.7-1.3 1.7-2.6 2.4-3.9 1-2-1 1.7-1.2 1.4-.1-.1 1.2-1.4 1.3-1.5.9-.9 1.8-1.9 2.8-2.8.1-.1 1.4-1.3 1.5-1.3.3.1-3.5 2.2-1.4 1.2 1.3-.7 2.6-1.7 3.9-2.4.6-.3 1.2-.5 1.8-.9 1.9-1.1-1.7.9-1.7.7s3.5-1.1 3.8-1.2c.6-.2 1.3-.3 2-.4 2.1-.6-1.8.2-2 .2 1.2.3 2.9-.2 4.1-.2h802.1c1.3 0 3 .5 4.3.2-.2 0-4-.8-2-.2.6.2 1.3.3 2 .4.9.2 1.7.5 2.6.7 1.8.5.9-.3.1-.1-1.1.3-1.6-.8 0 0 .6.3 1.2.6 1.7.9 1.1.6 2.2 1.5 3.3 2.1 2 1-1.7-1-1.4-1.2.1-.1 1.4 1.2 1.5 1.3.9.9 1.9 1.8 2.8 2.8.1.1 1.3 1.4 1.3 1.5-.1.3-2.2-3.5-1.2-1.4.6 1.2 1.4 2.2 2.1 3.3.3.6.6 1.2.9 1.7.9 1.6-.2 1.1 0 0 .2-.9-.6-1.7-.1.1.2.6.4 1.3.6 1.9.2.8.9 5.1.6 2-.9-3.1-.5 2.4-.5 3.1.2 10.5 9.1 20.5 20 20 10.7-.5 20.2-8.8 20-20-.6-31.9-25.7-57.8-57.6-59-1.8-.1-3.6 0-5.4 0H112.6c-33.4.1-60.5 26-60.7 59.7-.1 10.6 0 21.2 0 31.9V766c0 2.9-.1 5.8.1 8.7 2.2 31.2 27.4 55.8 58.9 56.2 5.5.1 11 0 16.5 0H902.4c15.2 0 30.1-.7 43.3-10 16.6-11.7 26.2-29.6 26.3-49.9V252.2c0-10.5-9.2-20.5-20-20-10.7.4-19.9 8.7-19.9 20z" fill="#5276E4" opacity="1" data-original="#000000" class="hovered-path"></path><path d="M932.1 350.4v127.7l20-20H107.7c-11.4 0-22.9-.3-34.3 0h-1.5l20 20V350.4l-20 20h844.4c11.4 0 22.9.2 34.3 0h1.5c10.5 0 20.5-9.2 20-20s-8.8-20-20-20H107.7c-11.4 0-22.9-.2-34.3 0h-1.5c-10.8 0-20 9.2-20 20v127.7c0 10.8 9.2 20 20 20h844.4c11.4 0 22.9.2 34.3 0h1.5c10.8 0 20-9.2 20-20V350.4c0-10.5-9.2-20.5-20-20s-20 8.8-20 20zM287.5 681.4H174.9c-10.5 0-20.5 9.2-20 20s8.8 20 20 20h112.6c10.5 0 20.5-9.2 20-20-.5-10.9-8.8-20-20-20zM651.9 681.4h-265c-10.5 0-20.5 9.2-20 20s8.8 20 20 20h265c10.5 0 20.5-9.2 20-20-.5-10.9-8.8-20-20-20z" fill="#5276E4" opacity="1" data-original="#000000" class="hovered-path"></path></g></svg>
              <div class="content">
                <div class="title" [ngStyle]="{'color': selectedThemeColor}">Credit</div>
                <div class="desc">directly reduces tax owed</div>
              </div>
            </div>
          
            <div class="tax-item">
              <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="60" height="60" x="0" y="0" viewBox="0 0 16.933 16.933" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M.53 1.323v4.761c0 .146.117.265.263.266H2.91c.147 0 .265-.12.264-.266v-.555c.41.246 1.075.555 1.854.555h2.38a1.06 1.06 0 0 0 1.06-1.056c0-.582-.478-1.06-1.06-1.06H5.82v-.265c0-.15.115-.263.266-.263h8.467c.151 0 .264.112.264.263v4.764a.257.257 0 0 1-.264.263H6.086a.259.259 0 0 1-.266-.263V6.879c-.007-.345-.521-.345-.529 0v1.588c0 .435.36.793.795.793h8.467a.797.797 0 0 0 .793-.793V3.703a.796.796 0 0 0-.793-.792H10.67L8.885 1.637c-.927-.663-2.134-.7-3.02-.49l-2.691.636v-.46a.265.265 0 0 0-.264-.264H.78a.266.266 0 0 0-.25.264zm8.048.744 1.18.844H6.087a.798.798 0 0 0-.795.792v.53c0 .146.12.265.266.265h1.851c.298 0 .53.232.53.53 0 .298-.232.529-.53.529h-2.38c-.897 0-1.64-.505-1.854-.664V2.325l2.818-.664c.86-.203 1.891-.091 2.586.406zm-7.52-.479h1.589V5.82H1.059zm7.911 2.38c-.345.026-.318.54.027.53h4c.101.344.32.632.762.764v1.652c-.4.096-.658.414-.76.758h-5.36c-.06-.26-.265-.618-.759-.76.01-.42-.536-.368-.529-.033v.264c0 .147.119.266.266.265.295 0 .527.234.527.53 0 .146.12.264.265.263h5.82a.265.265 0 0 0 .266-.263c0-.296.235-.53.53-.53.146 0 .264-.119.264-.265V5.028a.265.265 0 0 0-.264-.266.526.526 0 0 1-.53-.53.265.265 0 0 0-.265-.263H8.996a.24.24 0 0 0-.027 0zm1.35 1.06c-.582 0-1.06.475-1.06 1.056 0 .581.478 1.059 1.06 1.059.581 0 1.058-.478 1.058-1.059S10.9 5.028 10.32 5.028zm0 .529c.295 0 .529.232.529.527s-.234.53-.53.53a.526.526 0 0 1-.529-.53c0-.295.234-.527.53-.527zm.483 10.229-.007.002 2.963-.644v.465c0 .148.119.267.266.266h2.115a.265.265 0 0 0 .266-.266v-4.761a.265.265 0 0 0-.266-.266h-2.115a.265.265 0 0 0-.266.266v.554c-.41-.247-1.074-.554-1.851-.554h-2.91c-.582 0-1.059.477-1.059 1.058s.477 1.06 1.058 1.06h2.381c.353 0 .353-.53 0-.53h-2.38a.522.522 0 0 1-.53-.53c0-.297.232-.529.53-.529h2.91c.895 0 1.636.502 1.85.661v2.565l-3.075.667-.008.002c-.469.118-1.698.226-2.588-.41l-3.85-2.465c-.233-.15-.357-.478-.204-.73.183-.299.567-.228.784-.167l2.262.632c.344.103.49-.42.142-.51L4.96 10.99c-.598-.167-1.118-.04-1.385.413-.295.501-.1 1.134.377 1.44l3.833 2.454c1.086.775 2.429.637 3.018.49zm3.486-4.674h1.588v4.234h-1.588c.007-1.408 0-2.818 0-4.234z" fill="#5276E4" opacity="1" data-original="#000000" class=""></path></g></svg>
              <div class="content">
                <div class="title" [ngStyle]="{'color': selectedThemeColor}">Deferral</div>
                <div class="desc">delays tax liability to a future year</div>
              </div>
              <!--New icon for exclusion-->
            </div>
            <div class="tax-item">
              <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="60" height="60" viewBox="0 0 400 440" xml:space="preserve" class="hovered-paths"><g fill-rule="evenodd" clip-rule="evenodd"><path d="M0 0 C0.68087677 0.3085643 1.36175354 0.6171286 2.06326294 0.93504333 C3.5351143 1.60408644 5.00389254 2.27992391 6.46981812 2.96185303 C8.83308694 4.06108417 11.20384061 5.14240506 13.57739258 6.21923828 C16.08301765 7.35600018 18.58818621 8.49364198 21.09104919 9.63647461 C29.18596151 13.33045795 37.33575905 16.89225371 45.49957275 20.43078613 C49.54206911 22.18366069 53.58135718 23.9439019 57.62109375 25.703125 C58.84036057 26.23385117 58.84036057 26.23385117 60.08425903 26.77529907 C69.12782961 30.71182361 78.16986868 34.65179927 87.20571899 38.60601807 C88.97634961 39.38025192 90.74747312 40.15335972 92.51913452 40.92523193 C119.14425692 52.52706942 119.14425692 52.52706942 121.71484375 55.09765625 C121.81814024 57.07976137 121.85007083 59.06559645 121.85528564 61.05038452 C121.86099579 62.34532333 121.86670593 63.64026215 121.87258911 64.97444153 C121.87383471 66.42355337 121.87495976 67.87266532 121.87597656 69.32177734 C121.88060294 70.8378766 121.88562735 72.35397469 121.89102173 73.87007141 C121.90418278 78.00545311 121.91060023 82.14081854 121.91503239 86.27621794 C121.91796288 88.86590639 121.92206809 91.45559042 121.92653656 94.04527664 C121.94023378 102.16380874 121.94988419 110.28233069 121.95373845 118.40087354 C121.95819649 127.73894135 121.97562915 137.07686112 122.00473905 146.41488397 C122.02649185 153.64741601 122.03645025 160.87990688 122.03777957 168.11247122 C122.03881981 172.42290216 122.04455628 176.73319439 122.06259918 181.04359055 C122.22316024 221.70934895 122.22316024 221.70934895 115.96484375 241.28515625 C115.57969604 242.5222937 115.57969604 242.5222937 115.18676758 243.78442383 C112.6069982 251.83097669 109.41348314 259.50639941 105.71484375 267.09765625 C105.3811377 267.78956055 105.04743164 268.48146484 104.70361328 269.19433594 C99.4210875 280.01550997 93.18378217 289.66517887 85.71484375 299.09765625 C84.52375 300.62519531 84.52375 300.62519531 83.30859375 302.18359375 C71.1077503 317.20298648 57.06424399 331.54043113 41.36425781 342.89697266 C39.65601964 344.140477 37.97766108 345.41770693 36.30078125 346.703125 C28.92335132 352.30578626 21.27083896 357.42408998 13.46484375 362.41015625 C12.56636719 362.98483643 11.66789063 363.5595166 10.7421875 364.15161133 C6.18688773 367.0274361 1.58431198 369.82356458 -3.08203125 372.515625 C-3.93635742 373.01215576 -4.79068359 373.50868652 -5.67089844 374.02026367 C-8.76416124 375.29506464 -10.96648368 375.38514689 -14.28515625 375.09765625 C-16.74196213 374.0320537 -18.87455186 372.95273771 -21.16015625 371.59765625 C-21.83216064 371.20892334 -22.50416504 370.82019043 -23.1965332 370.41967773 C-38.52368761 361.37551396 -53.49294787 351.35621309 -67.28515625 340.09765625 C-68.2390625 339.34613281 -69.19296875 338.59460938 -70.17578125 337.8203125 C-92.9531361 319.33561299 -113.01207626 297.39608684 -126.28515625 271.09765625 C-126.63126953 270.42702148 -126.97738281 269.75638672 -127.33398438 269.06542969 C-139.03875742 246.227111 -144.36785422 222.44423016 -144.52563477 196.85668945 C-144.53846509 195.31684116 -144.55160094 193.77699539 -144.5650177 192.2371521 C-144.68032743 178.25475435 -144.7374462 164.27167563 -144.78178501 150.28889179 C-144.8150984 139.959881 -144.87485652 129.63174081 -144.96929604 119.30310374 C-145.03355866 112.02905081 -145.06730963 104.75523596 -145.07853454 97.48091 C-145.08609847 93.13933206 -145.1073105 88.79881099 -145.16156197 84.45754433 C-145.21194679 80.37853537 -145.22462176 76.30114504 -145.20831108 72.22187424 C-145.20891533 70.72583032 -145.22322025 69.22971949 -145.2522583 67.73395729 C-145.45991858 56.44757095 -145.45991858 56.44757095 -142.58460903 53.14356422 C-140.51116838 51.81082036 -138.598851 50.93194215 -136.28515625 50.09765625 C-134.93054745 49.45516011 -133.57902977 48.8060624 -132.23217773 48.14746094 C-130.7930082 47.51505897 -129.35087878 46.88936096 -127.90625 46.26953125 C-127.11416641 45.92355896 -126.32208282 45.57758667 -125.5059967 45.22113037 C-122.91409328 44.09069033 -120.31842727 42.96918314 -117.72265625 41.84765625 C-115.88515706 41.04812242 -114.04792182 40.2479817 -112.2109375 39.44726562 C-108.42449696 37.79799575 -104.6365404 36.15228786 -100.84716797 34.50976562 C-94.87519306 31.92101832 -88.90804224 29.32129038 -82.94226074 26.7183075 C-78.97143724 24.98591314 -74.99956807 23.2560339 -71.02490234 21.5324707 C-63.28617348 18.17345445 -55.56300896 14.7849209 -47.87088013 11.32028198 C-44.11022396 9.62713089 -40.34496967 7.94433359 -36.57958984 6.26171875 C-34.77652938 5.45219455 -32.97584426 4.63735616 -31.17773438 3.81689453 C-28.67896331 2.67703 -26.17262499 1.55561499 -23.6640625 0.4375 C-22.932444 0.09778671 -22.2008255 -0.24192657 -21.44703674 -0.5919342 C-13.74144788 -3.98211677 -7.69750716 -3.6612526 0 0 Z M-20.515625 11.65625 C-21.36077164 12.03158371 -22.20591827 12.40691742 -23.07667542 12.79362488 C-24.91204105 13.60908497 -26.74668218 14.42617722 -28.58068848 15.24468994 C-33.49829374 17.43904493 -38.4214006 19.62100075 -43.34375 21.8046875 C-44.85208908 22.47440582 -44.85208908 22.47440582 -46.39089966 23.15765381 C-55.92129591 27.38679534 -65.47424874 31.56304784 -75.03515625 35.72265625 C-76.61370269 36.41004149 -78.19223459 37.09746012 -79.77075195 37.78491211 C-87.36323702 41.09046028 -94.95821769 44.39023529 -102.5546875 47.68661499 C-106.20925081 49.27294299 -109.86304238 50.8610435 -113.51672363 52.44940186 C-116.1155125 53.57826389 -118.71545312 54.70444319 -121.31542969 55.83056641 C-122.88612947 56.51320426 -124.45677077 57.1959767 -126.02734375 57.87890625 C-126.75132355 58.1915744 -127.47530334 58.50424255 -128.22122192 58.8263855 C-131.48747922 60.08972875 -131.48747922 60.08972875 -134.28515625 62.09765625 C-134.38564281 63.74962207 -134.4159185 65.4058965 -134.41886902 67.06091309 C-134.423134 68.13682709 -134.42739899 69.21274109 -134.43179321 70.32125854 C-134.43134003 71.51268463 -134.43088684 72.70411072 -134.43041992 73.93164062 C-134.43377853 75.17910065 -134.43713715 76.42656067 -134.44059753 77.71182251 C-134.4485029 81.15136722 -134.45177763 84.59085154 -134.45241332 88.03040123 C-134.45312431 90.18930188 -134.45526001 92.34819625 -134.45791054 94.50709534 C-134.46718946 102.07016396 -134.47124406 109.63321494 -134.47045898 117.19628906 C-134.46986413 124.18781559 -134.4802913 131.17926345 -134.49620265 138.17077017 C-134.50943348 144.20510508 -134.51463617 150.23941489 -134.51400357 156.27376413 C-134.51375219 159.86224015 -134.51639588 163.450647 -134.52718163 167.03910828 C-134.56516767 180.67418541 -134.46856833 194.25982027 -133.41137695 207.86132812 C-133.33589473 208.84095268 -133.2604125 209.82057724 -133.18264294 210.82988739 C-130.61390117 239.98007154 -118.37255068 268.24215627 -100.28515625 291.09765625 C-99.50398438 292.10054688 -98.7228125 293.1034375 -97.91796875 294.13671875 C-85.48119538 309.44053645 -71.20285485 323.46018144 -55.28515625 335.09765625 C-54.29644531 335.85820312 -53.30773437 336.61875 -52.2890625 337.40234375 C-44.53645742 343.35321458 -36.49712797 348.80848608 -28.28515625 354.09765625 C-27.60888184 354.53770996 -26.93260742 354.97776367 -26.23583984 355.43115234 C-24.22131116 356.73366166 -22.19375788 358.01267897 -20.16015625 359.28515625 C-19.54487061 359.68412109 -18.92958496 360.08308594 -18.2956543 360.49414062 C-15.7008184 362.08478972 -13.83525365 363.10784324 -10.75390625 363.05078125 C12.90342189 353.91725583 35.61987767 334.21928505 53.71484375 317.09765625 C54.33665527 316.50984375 54.9584668 315.92203125 55.59912109 315.31640625 C90.17693221 282.34933734 110.14054487 242.16336859 111.71484375 194.09765625 C111.87819756 184.639373 111.83544876 175.17866953 111.81623769 165.71931911 C111.80990524 162.06520577 111.80939265 158.41109124 111.80821228 154.75697327 C111.8051277 147.86558441 111.79695383 140.97421178 111.78686279 134.08283001 C111.77561142 126.22527194 111.77016866 118.36771302 111.76516736 110.51014888 C111.75476818 94.3726419 111.73722553 78.23515116 111.71484375 62.09765625 C109.78740334 61.13004005 107.85951745 60.16331118 105.93144226 59.19696045 C104.85789836 58.65851879 103.78435446 58.12007713 102.67827892 57.56531906 C99.62670371 56.05400426 96.55329289 54.63868434 93.421875 53.30078125 C92.3191626 52.82672852 91.2164502 52.35267578 90.08032227 51.86425781 C88.90783936 51.3637793 87.73535645 50.86330078 86.52734375 50.34765625 C83.86498789 49.20390465 81.20395099 48.05709943 78.54296875 46.91015625 C77.48971153 46.45663788 77.48971153 46.45663788 76.41517639 45.99395752 C68.38095564 42.53052099 60.37277552 39.00805089 52.36437988 35.4854126 C48.03405354 33.58097214 43.70251443 31.67929364 39.37109375 29.77734375 C37.61197443 29.00489359 35.85285988 28.23243257 34.09375 27.45996094 C33.21299805 27.0732019 32.33224609 26.68644287 31.42480469 26.28796387 C28.65277931 25.07039542 25.88106979 23.85210985 23.109375 22.63378906 C18.5379097 20.62484585 13.96472214 18.61986946 9.39035034 16.61755371 C7.65582243 15.85756458 5.92186863 15.09626374 4.18850708 14.33361816 C1.79381046 13.2802109 -0.60282469 12.23134552 -3 11.18359375 C-3.7125293 10.86891144 -4.42505859 10.55422913 -5.15917969 10.23001099 C-11.64332163 7.40701396 -14.26368902 8.85266448 -20.515625 11.65625 Z" fill="#5276E4" transform="translate(211.285, 21.902)" class="hovered-path"></path><path d="M0 0 C3.63 0 7.26 0 11 0 C11 8.91 11 17.82 11 27 C13.97 27 16.94 27 20 27 C22.81866851 27.4759827 25.48947763 28.00131301 28.25 28.6875 C28.91128906 28.83638672 29.57257813 28.98527344 30.25390625 29.13867188 C37.19410067 30.80510274 43.1776207 33.37600796 50 36 C50 45.24 50 54.48 50 64 C45.71 64 41.42 64 37 64 C36.484375 62.02 35.96875 60.04 35.4375 58 C33.15903218 50.70413961 30.40581723 45.35435858 23.5 41.6640625 C19.32531899 39.91218743 15.46317765 38.89263553 11 38 C11 52.85 11 67.7 11 83 C14.3 83.66 17.6 84.32 21 85 C35.03484531 89.53325504 47.47772492 96.20241518 54.9375 109.4375 C57.77512225 118.39374524 57.37641636 130.4137651 53.25 138.8671875 C46.54930503 150.30024829 37.66860061 156.24118443 25 160 C18.565 160.99 18.565 160.99 12 162 C11.67 170.91 11.34 179.82 11 189 C7.37 189 3.74 189 0 189 C0 179.76 0 170.52 0 161 C-3.96 161 -7.92 161 -12 161 C-16.21484375 160.30078125 -16.21484375 160.30078125 -19.9375 159.3125 C-20.60209229 159.13678467 -21.26668457 158.96106934 -21.95141602 158.7800293 C-38.84987997 154.15012003 -38.84987997 154.15012003 -42 151 C-42.08775605 148.85441173 -42.10695219 146.70595579 -42.09765625 144.55859375 C-42.09443359 143.25341797 -42.09121094 141.94824219 -42.08789062 140.60351562 C-42.07953401 139.2148431 -42.07106905 137.82617123 -42.0625 136.4375 C-42.05748666 135.04492344 -42.05292347 133.65234519 -42.04882812 132.25976562 C-42.03699434 128.8398013 -42.0205088 125.41992156 -42 122 C-38.04 122 -34.08 122 -30 122 C-29.85304687 122.83402344 -29.70609375 123.66804688 -29.5546875 124.52734375 C-27.93041789 132.67669644 -26.02113377 139.98767849 -19.2890625 145.3671875 C-13.19956395 148.88727738 -7.13630369 148.90210712 0 150 C0 134.16 0 118.32 0 102 C-3.96 101.01 -7.92 100.02 -12 99 C-14.87251726 97.80141406 -17.52106196 96.62952538 -20.25 95.1875 C-20.9303833 94.83421631 -21.6107666 94.48093262 -22.31176758 94.11694336 C-31.94411854 89.01719165 -37.91556265 84.37424741 -41.78125 73.87890625 C-44.62365796 63.68737769 -42.80090252 53.76576867 -37.71875 44.65625 C-31.82875318 35.55352764 -23.26275479 30.30086171 -12.66796875 27.9609375 C-8.79108143 27.17164229 -4.92022781 26.60831121 -1 26 C-0.67 17.42 -0.34 8.84 0 0 Z M-14.77734375 42.58203125 C-19.31038048 47.66922894 -21.46076515 51.95445042 -21.25 58.94921875 C-20.50507713 65.05991415 -17.5476873 69.08687372 -13 73 C-8.45933852 76.45485113 -5.7953187 77.34419466 0 79 C0 65.47 0 51.94 0 38 C-5.79553411 38 -10.33833845 38.63082873 -14.77734375 42.58203125 Z M11 106 C11 120.52 11 135.04 11 150 C19.75872262 149.0268086 23.70023638 148.41456313 29.609375 142.34765625 C34.01462045 136.49461945 33.94797171 130.05110384 33 123 C31.25828972 117.06087613 26.17459626 112.15791071 21 109 C17.7 108.01 14.4 107.02 11 106 Z " fill="#5276E4"  transform="translate(193, 130)"class="hovered-path"></path></g></svg>
              <div class="content">
                <div class="title" [ngStyle]="{'color': selectedThemeColor}">Exclusion</div>
                <div class="desc">permanent elimination of tax</div>
            </div> 
          </div>
           <p>
            The Amount Type helps explain the mechanism through which tax savings are generated.
          </p>
          </div>
          <table class="info-table mb-5" border="0">
            <tr>
              <td class="left" width="18%" [style.--primary-theme-color]="selectedThemeColor">
                <div class="title-text">Estimated Savings</div>
              </td>
              <td class="right">
                Estimated Savings reflects the projected reduction in tax liability based on current assumptions, tax rates, and timely implementation. Actual results may vary based on final execution and tax return data.
              </td>
            </tr>

            <tr>
              <td class="left" width="18%" [style.--primary-theme-color]="selectedThemeColor">
                <div class="title-text">Due Date</div>
              </td>
              <td class="right">
                Due Date represents a highly recommended timeframe for completing actions related to a strategy. Meeting the Due Date helps ensure the strategy can be implemented as intended. Delays may impact eligibility, timing, or the amount of potential tax savings. Some strategies cannot be implemented retroactively.
              </td>
            </tr>

            <tr>
              <td class="left" width="18%" [style.--primary-theme-color]="selectedThemeColor">
                <div class="title-text">Estimated Strategy Investment</div>
              </td>
              <td class="right">
                Estimated Strategy Investment reflects whether a strategy requires new cash, reallocates existing cash, or does not require additional cash out of pocket. When applicable, this amount represents the estimated cash required to implement the strategy.
              </td>
            </tr>

            <tr>
              <td class="left" width="18%" [style.--primary-theme-color]="selectedThemeColor">
                <div class="title-text">Third-Party Fees</div>
              </td>
              <td class="right">
                Third-Party Fees are estimated costs paid to external providers such as engineers, attorneys, or investment sponsors required to implement certain strategies.
              </td>
            </tr>
          </table>
          </div>
          <div class="logo-theme-3"><span [ngStyle]="logoBg"></span></div>
          <div class="page-footer d-flex justify-content-end align-items-center mt-5">
            <div class="page-no ms-3" [ngStyle]="{'height': '0px', 'color': '#ffffff'}"> Page | <strong>2</strong></div>
          </div>
      </div>
      <div class="row theme border index-page-v2 d-flex flex-column mt-3" [style.background-image]="contentSvg" id="taxStrategies">
        <div class="d-flex flex-column">
          <h3 [ngStyle]="{'color': selectedThemeColor}">Tax Savings Strategies</h3>
        </div>
        <h4 [ngStyle]="{'color': selectedThemeColor}">Strategy Impact Overview</h4>
        <p>This section summarizes the tax strategies included in your plan and how each contributes to your overall estimated tax savings. Detailed explanations and next steps for each strategy are provided in the sections that follow.</p>
        <h4>Tax Savings Summary</h4>
        <div class="d-flex flex-column mt-2 mb-5 flex-grow-1">
          <table class="table table-bordered text-center table-striped theme-table" [style.--text-color]="selectedTextColor">
            <thead [style.--secondry-theme-color]="selectedThemeSecColor">
              <tr [ngStyle]="{'background-color': selectedThemeSecColor, 'color': '#ffffff'}">
                <th class="text-start fs-6 p-3">Strategy</th>
                <th class="text-start fs-6 p-3">Related Party</th>
                <th class="text-start fs-6 p-3">Amount</th>
                <th class="text-start fs-6 p-3">Amount Type</th>
                <th class="text-start fs-6 p-3">Estimated Savings</th>
              </tr>
            </thead>

            <tbody>
              <tr *ngFor="let strategy of reportData">
                <td class="text-start fs-6 p-3">{{ strategy.name }}</td>
                <td class="text-start fs-6 p-3">{{ strategy.relatedParty }}</td>
                <td class="text-start fs-6 p-3">{{ strategy.planAmount | formatAmount:'$0,0' }}</td>
                <td class="text-start fs-6 p-3">{{ strategy.amountType }}</td>
                <td class="text-start fs-6 p-3">{{strategy.estimatedSavings | formatAmount:'$0,0'}}</td>
              </tr>
              <tr class="fw-bold table-light total-row" [style.--primary-theme-color]="selectedThemeColor" >
              <td colspan="3"></td>
              <td class="text-start fs-6 p-3 total-highlight">Total Savings</td>
              <td class="text-start fs-6 p-3 total-highlight">{{ totalSavings | formatAmount:'$0,0' }}</td>
            </tr>
            </tbody>

          </table>
        </div>
        <div class="d-flex flex-wrap mt-5 mb-5" *ngIf="listOfStrategies.length === 0">
          No strategies available.
        </div>
        <div class="logo-theme-3"><span [ngStyle]="logoBg"></span></div>
        <div class="page-footer d-flex justify-content-end align-items-center mt-5">
          <div class="page-no ms-3" [ngStyle]="{'height': '0px', 'color': '#ffffff'}"> Page | <strong>3</strong></div>
        </div>
      </div>
      <div class="row theme border index-page-v2 d-flex flex-column mt-3" [style.background-image]="contentSvg" id="investmentFees">
        <div class="d-flex flex-column">
          <h3 [ngStyle]="{'color': selectedThemeColor}">Estimated Strategy Investment </h3>
        </div>
        <p>This section summarizes whether any additional cash is required to implement the strategies included in your tax plan. Many strategies reduce taxes without requiring new cash out of pocket. Some strategies may involve an investment of capital that continues to grow over time. Where applicable, estimated third-party fees are shown separately.</p>
        <div class="d-flex flex-column mt-2 mb-5 flex-grow-1" *ngIf="listOfStrategies.length > 0">
          <table class="table table-bordered text-center table-striped theme-table" [style.--text-color]="selectedTextColor">
            <thead [style.--secondry-theme-color]="selectedThemeSecColor">
              <tr>
                <th class="text-start fs-6 p-3">Strategy</th>
                <th class="text-start fs-6 p-3">Related Party</th>
                <th class="text-start fs-6 p-3">Estimated Strategy Investment</th>
              </tr>
            </thead>

            <tbody>
              <tr *ngFor="let strategy of reportData">
                <td class="text-start fs-6 p-3">{{ strategy.name }}</td>
                <td class="text-start fs-6 p-3">{{ strategy.relatedParty }}</td>
                <td class="text-start fs-6 p-3">{{
                strategy.investedAmount === 0.0
                  ? 'No Strategy Investment Required'
                  : (strategy.investedAmount | formatAmount:'$0,0')
              }}</td>
              </tr>
              <!-- <tr>
                <td class="text-start fs-6 p-3">Third Party Fees</td>
                <td class="text-start fs-6 p-3"></td>
                <td class="text-start fs-6 p-3">-{{totalThirdPartyFees | formatAmount:'$0,0'}}</td>
              </tr> -->
              <tr class="fw-bold table-light total-row" [style.--primary-theme-color]="selectedThemeColor">
              <td colspan="1"></td>
              <td class="text-start fs-6 p-3 total-highlight">Total Strategy Investment</td>
              <td class="text-start fs-6 p-3 total-highlight">{{totalInvestedAmount | formatAmount:'$0,0'}}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="d-flex flex-wrap mt-5 mb-5" *ngIf="listOfStrategies.length === 0">
          No strategies available.
        </div>
        <div class="logo-theme-3"><span [ngStyle]="logoBg"></span></div>
        <div class="page-footer d-flex justify-content-end align-items-center mt-5">
            <div class="page-no ms-3" [ngStyle]="{'height': '0px', 'color': '#ffffff'}"> Page | <strong>4</strong></div>
        </div>
      </div>
      <div  class="row theme border index-page-v2 d-flex align-items-center mt-3"  [style.background-image]="contentSvg" *ngFor="let strategy of reportData; index as i"  [id]="'strategy-' + i">
        <div class="strategy-info d-flex flex-column">
          <h3 [ngStyle]="{'color': selectedThemeColor}">{{strategy.name}}</h3>
          <table class="table table-bordered theme-table">
            <tbody [style.--secondry-theme-color]="selectedThemeSecColor">
              <tr>
                <th class="text-start">Tax Category</th>
                <td class="text-end">{{strategy.category}}</td>
              </tr>
      
              <tr>
                <th class="text-start">Related Party</th>
                <td class="text-end">{{strategy.relatedParty}}</td>
              </tr>
      
              <tr>
                <th class="text-start">Amount (deduction or credit)</th>
                <td class="text-end">{{strategy.planAmount | formatAmount:'$0,0'}}</td>
              </tr>
      
              <tr>
                <th class="text-start">Estimated Strategy Investment</th>
                <td class="text-end">{{ strategy?.investedAmount > 0
      ? (strategy.investedAmount | formatAmount:'$0,0')
      : 'No Strategy Investment Required' }}</td>
              </tr>
      
              <tr>
                <th class="text-start">Estimated Federal Tax Savings</th>
                <td class="text-end">{{strategy.taxSavings | formatAmount:'$0,0'}}</td>
              </tr>
      
              <tr>
                <th class="text-start">Estimated State Tax Savings</th>
                <td class="text-end">{{strategy.stateTaxSavings | formatAmount:'$0,0'}}</td>
              </tr>
            </tbody>
          </table>
          <div class="client-overview mt-3">
            <h4 [ngStyle]="{'color': selectedThemeColor}">What This Strategy Is</h4>
            <div *ngIf="strategy.clientOverview" class="text report-strategy-content mt-2 word-wrap" #clientoverview id="overview-{{strategy.id}}"  [innerHTML]="strategy.clientOverview"></div>
            <div *ngIf="!strategy.clientOverview" class="text report-strategy-content mt-2 mb-2">No data available.</div>
          </div>
          <div class="client-overview mt-3 mb-3">
            <h4 [ngStyle]="{'color': selectedThemeColor}">Why This Applies to You</h4>
            <div *ngIf="strategy.reportCustomText" class="text report-strategy-content mt-2 word-wrap"
              [innerHTML]="strategy.reportCustomText"></div>
            <div *ngIf="!strategy.reportCustomText" class="text report-strategy-content mt-2 mb-2">No data
              available.</div>
          </div>
          <!-- <div class="client-overview mt-3 mb-3">
            <h4 [ngStyle]="{'color': selectedThemeColor}">Investment & Third-Party Fees</h4>
            <div class="text report-strategy-content mt-2 word-wrap">
              <p>This strategy does not require additional cash out of pocket to generate the tax benefit. Depreciation deductions are accelerated based on the existing cost of the property.</p>
              <p>A third-party cost segregation study is required. Estimated fees for this service are shown above and may vary based on property size and complexity.</p>
            </div>
          </div> -->
          <div>
            <h4 [ngStyle]="{'color': selectedThemeColor}">Eligibility Considerations</h4>
            <div class="text mt-2" *ngIf="strategy.criteria && strategy.criteria.length > 0">
              <ul>
                <li class="word-wrap" *ngFor="let criteria of strategy.criteria">{{criteria.text}}</li>
              </ul>
            </div>
            <div class="text mt-2 mb-2" *ngIf="strategy.criteria && strategy.criteria.length === 0">
              No data available.
            </div>
          </div>
          <!-- <table class="custom-opportunity-table w-100" [ngStyle]="{'color': '#ffffff'}"> -->
          <!-- Opportunities -->
          <!-- <tr [ngStyle]="{'background-color': selectedThemeSecColor}">
            <td class="label-cell p-3">
              OPPORTUNITIES
            </td>
            <td class="content-cell p-3">
              <ul *ngIf="strategy.opportunities?.length > 0">
                <li *ngFor="let opportunity of strategy.opportunities">
                  {{ opportunity.description }}
                </li>
              </ul>

              <div *ngIf="strategy.opportunities?.length === 0">
                No data available.
              </div>
            </td>
          </tr> -->

          <!-- Risks -->
          <!-- <tr>
            <td class="label-cell p-3" [style.background-color]="selectedThemeColor + ' !important'">
              RISKS
            </td>
            <td class="content-cell p-3" [style.background-color]="selectedThemeColor + ' !important'">
              <ul *ngIf="strategy.potentialRisks?.length > 0">
                <li *ngFor="let risk of strategy.potentialRisks">
                  {{ risk.description }}
                </li>
              </ul>

              <div *ngIf="strategy.potentialRisks?.length === 0">
                No data available.
              </div>
            </td>
          </tr>

          </table> -->
          <div>
            <h4 [ngStyle]="{'color': selectedThemeColor}">Client Education & Resources</h4>
            <div *ngIf="strategy.clientResources" class="text report-strategy-content mt-2 word-wrap" #clientresources
              id="resource-{{strategy.id}}" [innerHTML]="strategy.clientResources"></div>
            <div *ngIf="!strategy.clientResources" class="text report-strategy-content mt-2 mb-2">No data available.</div>
          </div>
        
          <div *ngIf="todoTaskStatus">
            <h4 [ngStyle]="{'color': selectedThemeColor}">Client Responsibilities</h4>
            <table class="table table-bordered text-center table-striped theme-table" [style.--text-color]="selectedTextColor">
            <thead [style.--secondry-theme-color]="selectedThemeSecColor">
              <tr>
                <th class="text-start fs-6 p-3">ToDo</th>
                <th class="text-start fs-6 p-3">Due Date</th>
              </tr>
            </thead>
            <tbody *ngIf="strategy.toDoDetails?.length > 0">
              <tr *ngFor="let item of strategy.toDoDetails">
                <td class="text-start fs-6 p-3">{{ item.name }}</td>
                <td class="text-start fs-6 p-3">{{ item.dueDate }}</td>
              </tr>
            </tbody>
            <tbody  *ngIf="!strategy.toDoDetails || strategy.toDoDetails.length === 0">
              <tr>
                <td class="text-start fs-6 p-3">No Data is available</td>
                <td class="text-start fs-6 p-3"></td>
              </tr>
            </tbody>
          </table>
          </div>
          <div class="mb-5" *ngIf="todoTaskStatus">
              <h4 [ngStyle]="{'color': selectedThemeColor}">{{clientTaxplanData.firmName}} Tax Advisors Responsibilities</h4>
              <table class="table table-bordered text-center table-striped theme-table" [style.--text-color]="selectedTextColor">
              <thead [style.--secondry-theme-color]="selectedThemeSecColor">
                <tr>
                  <th class="text-start fs-6 p-3">Task</th>
                  <th class="text-start fs-6 p-3">Due Date</th>
                </tr>
              </thead>
              <tbody *ngIf="strategy.taskDetails?.length > 0">
                <tr *ngFor="let item of strategy.taskDetails">
                  <td class="text-start fs-6 p-3">{{ item.title }}</td>
                  <td class="text-start fs-6 p-3">{{ item.dueDate }}</td>
                </tr>
              </tbody>
              <tbody  *ngIf="!strategy.taskDetails || strategy.taskDetails.length === 0">
              <tr>
                <td class="text-start fs-6 p-3">No Data is available</td>
                <td class="text-start fs-6 p-3"></td>
              </tr>
            </tbody>
            </table>
          </div>
        </div>
        <div class="logo-theme-3"><span [ngStyle]="logoBg"></span></div>
        <div class="page-footer d-flex justify-content-end align-items-center mt-5 w-100">
            <div class="page-no ms-3" [ngStyle]="{'height': '0px', 'color': '#ffffff'}"> Page | <strong>{{5+i}}</strong></div>
        </div>
      </div>
      <div class="row theme border index-page-v2 d-flex flex-column mt-3" [style.background-image]="contentSvg" id="finalNotes" [ngStyle]="{
       'background': selectedThemeColor, color:'#ffffff'}">
        <div class="mb-5 flex-grow-1">
            <h3 [ngStyle]="{'color': '#ffffff'}">Notes & Ongoing Planning</h3> 
            <p>Tax planning is an ongoing process. The strategies outlined in this report are based on current information, assumptions, and tax law. As your financial situation changes—or as tax laws and interpretations evolve—your tax plan should be reviewed and updated accordingly.</p>
              <p>Some strategies included in this plan may span multiple years or require coordination with third-party providers. Others may become more or less applicable over time. Regular review helps ensure your tax plan continues to align with your goals and maximizes potential benefits.</p>
            <p>If you have questions about this report or next steps, please contact {{clientTaxplanData.firmName}} Tax Advisors before taking action.</p>
            <div class="p-3 rounded" [ngStyle]="{'background': '#ffffff', 'color': selectedThemeColor}" >
              <h4 [ngStyle]="{'color': selectedThemeSecColor}">What Happens Next <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="50" height="50" x="0" y="0" viewBox="0 0 60 60" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M28.331 15.002 19.006 15l12.121 14.354a1 1 0 0 1 0 1.291L19.001 45.001l9.326-.002 12.672-15-12.668-14.998z" [attr.fill]="selectedThemeSecColor" opacity="1" data-original="#000000"></path><path d="M14.127 29.354a1 1 0 0 1 0 1.291L2.001 45.001l9.326-.002 12.672-15-12.668-14.998-9.325-.002 12.121 14.354zM36.006 15l12.121 14.354a1 1 0 0 1 0 1.291L36.001 45.001l9.326-.002 12.672-15-12.668-14.998-9.325-.002z" [attr.fill]="selectedThemeSecColor" opacity="1" data-original="#000000"></path></g></svg></h4>
              <ul style="padding-left: 40px;">
              <li *ngIf="overviewStatus">Complete any outstanding action items shown in the <b>Implementation Overview</b></li>
              <li>Coordinate with your tax professional as tasks are completed</li>
              <li>Revisit this plan prior to major financial decisions or annually as part of your tax planning process</li>
            </ul>
            </div>
        </div>
        <div class="logo-theme-3"><span [ngStyle]="logoBg"></span></div>
        <div class="page-footer d-flex justify-content-end align-items-center mt-5">
            <div class="page-no ms-3" [ngStyle]="{'height': '0px', 'color': '#ffffff'}"> Page | <strong>{{5+listOfStrategies.length}}</strong></div>
        </div>
      </div>
      <div class="row theme border index-page-v2 d-flex flex-column mt-3 mb-3" *ngIf="overviewStatus" [style.background-image]="contentSvg" id="implementation">
        <div class="d-flex flex-column mb-5">
          <h3 [ngStyle]="{'color': selectedThemeColor}">Implementation Overview</h3>
          <p>
            This page provides a high-level view of the actions that will be required to implement your tax plan. You do not need to complete these items immediately. Detailed explanations for each action are provided in the strategy sections that follow.
          </p>
          <div>
            <h4 [ngStyle]="{'color': selectedThemeColor}">Client Action Items</h4>
            <table class="table table-bordered text-center table-striped theme-table" [style.--text-color]="selectedTextColor" *ngIf="allToDoDetails && allToDoDetails.length  > 0">
            <thead [style.--secondry-theme-color]="selectedThemeSecColor">
              <tr>
                <th class="text-start fs-6 p-3">ToDo</th>
                <th class="text-start fs-6 p-3">Strategy</th>
                <th class="text-start fs-6 p-3">Due Date</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of allToDoDetails">
                <td class="text-start fs-6 p-3">{{ item.name }}</td>
                <td class="text-start fs-6 p-3">{{ item.strategyName }}</td>
                <td class="text-start fs-6 p-3">{{ item.dueDate }}</td>
              </tr>
            </tbody>
          </table>
            <div class="text mt-2 mb-2" *ngIf="allToDoDetails && allToDoDetails.length === 0">
              No data available.
            </div>
          </div>
          <div class="mb-3">
              <h4 [ngStyle]="{'color': selectedThemeColor}">{{clientTaxplanData.firmName}} Tax Action Items</h4>
              <table class="table table-bordered text-center table-striped theme-table" [style.--text-color]="selectedTextColor" *ngIf="allTaskDetails && allTaskDetails.length > 0">
              <thead [style.--secondry-theme-color]="selectedThemeSecColor">
                <tr>
                  <th class="text-start fs-6 p-3">Task</th>
                  <th class="text-start fs-6 p-3">Strategy</th>
                  <th class="text-start fs-6 p-3">Due Date</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of allTaskDetails">
                  <td class="text-start fs-6 p-3">{{ item.title }}</td>
                  <td class="text-start fs-6 p-3">{{ item.strategyName }}</td>
                  <td class="text-start fs-6 p-3">{{ item.dueDate }}</td>
                </tr>
              </tbody>
            </table>
              <div class="text mt-2 mb-2" *ngIf="allTaskDetails && allTaskDetails.length === 0">
                No data available.
              </div>
          </div>
          <div [ngStyle]="{'background': hexToRgba(selectedThemeColor, 0.09), 'padding': '20px'}" class="important-timing-note-section" [style.--primary-theme-color]="selectedTextColor"  >
          <h4 [ngStyle]="{'color': selectedThemeColor}">Important Timing Note</h4>
          <p>Some strategies depend on timely implementation. Completing action items within the recommended timeframes helps preserve strategy eligibility and projected tax savings. Certain strategies cannot be implemented retroactively.</p>
          </div>
          
        </div>
        <div class="logo-theme-3"><span [ngStyle]="logoBg"></span></div>
        <div class="page-footer d-flex justify-content-end align-items-center mt-5">
            <div class="page-no ms-3" [ngStyle]="{'height': '0px', 'color': '#ffffff'}"> Page | <strong>{{6+listOfStrategies.length}}</strong></div>
          </div>
      </div>
    </ng-template>
    <!-- New Report Design Theme 1 and Theme 2 End -->
     <!-- Old Report Design Theme 1 and Theme 2 Start -->
    <ng-template [ngIf]="(selectedThemeName === 'theme1' || selectedThemeName === 'theme2') && !isReportingV2Enabled">
      <div class="row theme border intro-page d-flex align-items-center mt-3" [ngStyle]="{'background-image': 'url(' + introPageBgUrl + ')'}">
        <div class="d-flex justify-content-end mb-3 w-100" [ngClass]="{'org-logo' : selectedThemeName === 'theme2'}">
              <div class="mt-3" [ngStyle]="logoBg"></div>
        </div>
        <div class="d-flex flex-column title-page-content">
          <div class="text mt-2" *ngIf="selectedThemeName === 'theme1'">{{clientTaxplanData.name}}</div>
          <div class="report-title">TAX SAVINGS ANALYSIS FOR {{taxYear || ''}}</div>
          <div *ngIf="selectedThemeName === 'theme1'">
            <div class="mt-3" [ngStyle]="logoBg"></div>
          </div>
          <ng-template [ngIf]="selectedThemeName === 'theme2'">
            <div class="text mt-2">{{clientTaxplanData.name}}</div>
          </ng-template>
        </div>
        <div class="disclaimer-section mt-5 p-3 me-4" [innerHTML]="disclaimer">
        </div>
      </div>
      <div class="row theme border index-page d-flex flex-column mt-3" *ngIf="selectedThemeName == 'theme1'" [ngStyle]="{'background-image': 'url(' + contentPageBgUrl + ')'}">
        <div class="d-flex flex-column">
          <div class="list-of-strategies-heading">LIST OF STRATEGIES</div>
        </div>
        <div class="d-flex flex-column mt-4 mb-5" style="border: 1px solid" *ngIf="listOfStrategies.length > 0">
          <div class="d-flex pe-3 align-items-center list-item" style="border: 1px solid" *ngFor="let strategy of listOfStrategies;let i = index;">
            <div class="list-item-number d-flex align-items-center" style="border-right: 2px solid">{{i+1}}</div>
            <div class="list-item-name d-flex">{{strategy.strategyName}}</div>
          </div>
        </div>
        <div class="d-flex flex-wrap mt-5 mb-5" *ngIf="listOfStrategies.length === 0">
          No strategies available.
        </div>
        <div class="d-flex justify-content-end mb-3">
          <div class="logo-on-strategy-page mt-3" [ngStyle]="logoBg"></div>
        </div>
      </div>
      <div class="row theme border index-page d-flex flex-column mt-3" *ngIf="selectedThemeName == 'theme2'" [style.border-bottom]="'25px  solid ' + selectedThemeColor + ' !important'">
        <div class="list-of-data" [ngStyle]="{'border-left': '10px solid' + selectedThemeColor, 'border-bottom': '10px solid' + selectedThemeColor, 'padding-left': '20px', 'padding-bottom': '20px'}">
          <div class="d-flex justify-content-end mb-3" *ngIf="selectedThemeName === 'theme2'">
            <div class="logo-on-strategy-page" [ngStyle]="logoBg"></div>
          </div>
          <div class="d-flex flex-column">
            <div class="list-of-strategies-heading">LIST OF STRATEGIES</div>
          </div>
          <div class="d-flex flex-column mt-2 mb-5" *ngIf="listOfStrategies.length > 0">
            <div class="d-flex mt-2 mb-2 pe-3" *ngFor="let strategy of listOfStrategies;let i = index;">
              <div class="list-item-number">{{((i+1) <= 9) ? 0 : ''}}{{i+1}}</div>
              <div class="list-item-name">{{strategy.strategyName}}</div>
            </div>
          </div>
          <div class="d-flex flex-column mt-5 mb-5" *ngIf="listOfStrategies.length === 0">
            No strategies available.
          </div>
        </div>
      </div>
      <div class="row theme border data-page d-flex align-items-center mt-3"  [ngStyle]="{'background-image': selectedThemeName != 'theme2' ? 'url(' + contentPageBgUrl + ')' : ''}" *ngFor="let strategy of reportData">
        <div class="strategy-info d-flex flex-column" [ngStyle]="{'border-left': selectedThemeName == 'theme2' ? '10px solid' + selectedThemeColor : '', 'border-bottom': selectedThemeName == 'theme2' ? '10px solid' + selectedThemeColor : '', 'padding-left': selectedThemeName == 'theme2' ? '20px' : '', 'padding-bottom': selectedThemeName == 'theme2' ? '20px' : ''}">
          <div class="d-flex justify-content-end mb-3" *ngIf="selectedThemeName === 'theme2'">
            <div class="logo-on-strategy-page" [ngStyle]="logoBg"></div>
          </div>
          <div class="name mb-3" [ngStyle]="{'color': selectedTextColor}">{{strategy.name}}</div>
          <div class="client-overview mt-3">
            <div class="heading" [ngStyle]="{'border-bottom': '2px solid' + selectedThemeColor, 'padding-bottom': '0.5rem'}">CLIENT OVERVIEW:</div>
            <div *ngIf="strategy.clientOverview" class="text report-strategy-content mt-2 word-wrap" #clientoverview id="overview-{{strategy.id}}" [innerHTML]="strategy.clientOverview"></div>
            <div *ngIf="!strategy.clientOverview" class="text report-strategy-content mt-2 mb-2">No data available.</div>
          </div>
          <div class="related-plan-row mt-4 mb-4">
          <div class="related-plan-grid">
            <div class="col">
              <div class="heading" [ngStyle]="{'color': selectedTextColor}">
                Related Party
              </div>
              <div class="value" [ngStyle]="{'color': selectedThemeColor}">
                {{strategy.relatedParty || '—'}}
              </div>
            </div>

            <div class="col">
              <div class="heading" [ngStyle]="{'color': selectedTextColor}">
                 Amount
              </div>
              <div class="value" [ngStyle]="{'color': selectedThemeColor}">
                {{strategy.planAmount | formatAmount:'$0,0'}}
              </div>
            </div>

          </div>
          </div>
          <div class="d-flex savings-info">
            <div class="item pe-3">
              <div class="heading">Fed Associated Rate</div>
              <div class="text" [ngStyle]="{'color': selectedThemeColor}">{{strategy.associatedRate}}%</div>
            </div>
            <div class="item pe-3">
              <div class="heading">Fed Tax Savings</div>
              <div class="text" [ngStyle]="{'color': selectedThemeColor}">{{strategy.taxSavings | formatAmount:'$0,0'}}</div>
            </div>
            <div class="item pe-3">
              <div class="heading">State Associated Rate</div>
              <div class="text" [ngStyle]="{'color': selectedThemeColor}">{{strategy.stateAssociatedRate}}%</div>
            </div>
            <div class="item pe-3">
              <div class="heading">State Tax Savings</div>
              <div class="text" [ngStyle]="{'color': selectedThemeColor}">{{strategy.stateTaxSavings | formatAmount:'$0,0'}}</div>
            </div>
          </div>
          <div class="heading mt-3" [ngStyle]="{'border-bottom': '2px solid' + selectedThemeColor, 'padding-bottom': '0.5rem'}">
            <span>GOAL TASK DATE: </span>
            <span>{{strategy.goalDate}}</span>
          </div>
          <div class="mb-3">
            <div class="text mt-2 mb-2">
              <span class="bold">Fed Associated With: </span>
              <span>{{strategy.associatedRateName || ''}}</span>
            </div>
            <div class="text mt-2 mb-2">
              <span class="bold">State Associated With: </span>
              <span>{{strategy.stateAssociatedRateName || ''}}</span>
            </div>
            <div class="text mt-2 mb-2">
              <span class="bold">Category: </span>
              <span>{{strategy.category}}</span>
            </div>
            <div class="text mt-2 mb-2">
              <span class="bold">Recurring: </span>
              <span>{{strategy.recurring}}</span>
            </div>
            <div class="text mt-2 mb-2">
              <span class="bold">Applicable To: </span>
              <span>{{strategy.applicableTo}}</span>
            </div>
            <div class="text mt-2 mb-2">
              <span class="bold">Complexity: </span>
              <span>{{strategy.complexity}}</span>
            </div>
            <div class="text mt-2 mb-2">
              <span class="bold">Deadline: </span>
              <span>{{strategy.deadline}}</span>
            </div>
          </div>
          <div>
            <div class="heading"[ngStyle]="{'border-bottom': '2px solid' + selectedThemeColor, 'padding-bottom': '0.5rem'}">ELIGIBILITY CRITERIA:</div>
            <div class="text mt-2" *ngIf="strategy.criteria && strategy.criteria.length > 0">
              <ul>
                <li class="word-wrap" *ngFor="let criteria of strategy.criteria">{{criteria.text}}</li>
              </ul>
            </div>
            <div class="text mt-2 mb-2" *ngIf="strategy.criteria && strategy.criteria.length === 0">
              No data available.
            </div>
          </div>
          <div>
            <div class="heading" [ngStyle]="{'border-bottom': '2px solid' + selectedThemeColor, 'padding-bottom': '0.5rem'}">CLIENT RESOURCES:</div>
            <div *ngIf="strategy.clientResources" class="text report-strategy-content mt-2 word-wrap" #clientresources id="resource-{{strategy.id}}" [innerHTML]="strategy.clientResources"></div>
            <div *ngIf="!strategy.clientResources" class="text report-strategy-content mt-2 mb-2">No data available.</div>
          </div>
          <div>
            <div class="heading" [ngStyle]="{'border-bottom': '2px solid' + selectedThemeColor, 'padding-bottom': '0.5rem'}">OPPORTUNITIES:</div>
            <div class="text mt-2" *ngIf="strategy.opportunities && strategy.opportunities.length > 0">
              <ul>
                <li class="word-wrap" *ngFor="let opportunity of strategy.opportunities">{{opportunity.description}}</li>
              </ul>
            </div>
            <div class="text mt-2 mb-2" *ngIf="strategy.opportunities && strategy.opportunities.length === 0">
              No data available.
            </div>
          </div>
          <div>
            <div class="heading" [ngStyle]="{'border-bottom': '2px solid' + selectedThemeColor, 'padding-bottom': '0.5rem'}">RISKS:</div>
            <div class="text mt-2" *ngIf="strategy.potentialRisks && strategy.potentialRisks.length > 0">
              <ul>
                <li class="word-wrap" *ngFor="let risk of strategy.potentialRisks">{{risk.description}}</li>
              </ul>
            </div>
            <div class="text mt-2 mb-2" *ngIf="strategy.potentialRisks && strategy.potentialRisks.length === 0">
              No data available.
            </div>
          </div>
          <div>
            <div class="heading" [ngStyle]="{'border-bottom': '2px solid' + selectedThemeColor, 'padding-bottom': '0.5rem'}">CLIENT TO DO'S:</div>
            <ng-template [ngIf]="strategy.clientTodos && strategy.clientTodos.length > 0">
              <div class="text client-todos mt-2" *ngFor="let todo of strategy.clientTodos;let i=index">
                <div class="heading"><span class="pe-2" [ngStyle]="{'color': selectedThemeColor}">{{((i+1) <= 9) ? 0 : ''}}{{i+1}}</span><span>{{todo.name}}</span></div>
                <div class="text word-wrap" #todotemplate id="todo``{{strategy.id}}``{{todo.id}}" [innerHTML]="todo.description"></div>
              </div>
            </ng-template>
            <div class="text mt-2 mb-2" *ngIf="strategy.clientTodos && strategy.clientTodos.length === 0">
              No data available.
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-end mb-3"  *ngIf="selectedThemeName === 'theme1'" [ngStyle]="{'width': '100%'}">
          <div class="logo-on-strategy-page">
            <div class="mt-3" [ngStyle]="logoBg"></div>
          </div>
        </div>
      </div>
    </ng-template>
    <!-- Old Report Design Theme 1 and Theme 2 End -->
    <ng-template [ngIf]="selectedThemeName === 'theme3' && !isReportingV2Enabled">
      <div class="row theme border intro-page d-flex align-items-center mt-3" [ngStyle]="{'background-image': 'url(' + introPageBgUrl + ')'}">
        <div class="d-flex flex-column title-page-content">
          <div class="report-title">TAX SAVINGS ANALYSIS FOR {{taxYear || ''}}</div>
          <div class="text mt-2">{{clientTaxplanData.name}}</div>
          <div class="org-logo">
            <div class="mt-3 " [ngStyle]="logoBg"></div>
          </div>
        </div>
        <div class="disclaimer-section mt-5 p-3 me-4" [innerHTML]="disclaimer">
        </div>
      </div>
      <div class="row theme border index-page d-flex flex-column mt-3 theme3-padding">
        <div class="d-flex">
          <div [ngStyle]="{'border-left': '50px solid' + selectedThemeColor, 'opacity':'0.3', 'height': '15rem'}"></div>
          <div class="theme3-style">
            <div [ngStyle]="{'border-bottom': '20px solid' + selectedThemeColor, 'width': '50%'}"></div>
            <div class="list-of-data">
              <div class="d-flex flex-column">
                <div class="list-of-strategies-heading">LIST OF STRATEGIES</div>
              </div>
              <div class="d-flex flex-column mt-4 mb-5" style="border: 1px solid" *ngIf="listOfStrategies.length > 0">
                <div class="d-flex pe-3 align-items-center list-item" style="border: 1px solid" *ngFor="let strategy of listOfStrategies;let i = index;">
                  <div class="list-item-number d-flex align-items-center" style="border-right: 2px solid">{{i+1}}</div>
                  <div class="list-item-name d-flex">{{strategy.strategyName}}</div>
                </div>
              </div>
              <div class="d-flex flex-column mt-5 mb-5" *ngIf="listOfStrategies.length === 0">
                No strategies available.
              </div>
            </div>
            <div class="d-flex mt-2 justify-content-end">
              <div class="logo-on-strategy-page" [ngStyle]="logoBg"></div>
              <div class="d-flex flex-column justify-content-center" style="width: 60%">
                <div [ngStyle]="{'border': '10px solid' + selectedThemeColor}"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row theme border data-page d-flex align-items-center mt-3 theme3-padding" *ngFor="let strategy of reportData">
        <div class="d-flex">
          <div [ngStyle]="{'border-left': '50px solid' + selectedThemeColor, 'opacity':'0.3', 'height': '15rem'}"></div>
          <div class="theme3-style">
            <div class="mb-4" [ngStyle]="{'border-bottom': '20px solid' + selectedThemeColor, 'width': '50%'}"></div>
            <div class="strategy-info d-flex flex-column">
              <div class="name mb-3" [ngStyle]="{'color': selectedTextColor}">{{strategy.name}}</div>
              <div class="client-overview mt-3">
                <div class="heading" [ngStyle]="{'border-bottom': '2px solid' + selectedThemeColor, 'padding-bottom': '0.5rem'}">CLIENT OVERVIEW:</div>
                <div *ngIf="strategy.clientOverview" class="text report-strategy-content mt-2 word-wrap" #clientoverview id="overview-{{strategy.id}}" [innerHTML]="strategy.clientOverview"></div>
                <div *ngIf="!strategy.clientOverview" class="text report-strategy-content mt-2 mb-2">No data available.</div>
              </div>
              <div class="related-plan-row mt-4 mb-4">
              <div class="related-plan-grid">
                <div class="col">
                  <div class="heading" [ngStyle]="{'color': selectedTextColor}">
                    Related Party
                  </div>
                  <div class="value" [ngStyle]="{'color': selectedThemeColor}">
                    {{strategy.relatedParty || '—'}}
                  </div>
                </div>
                <div class="col">
                  <div class="heading" [ngStyle]="{'color': selectedTextColor}">
                    Amount
                  </div>
                  <div class="value" [ngStyle]="{'color': selectedThemeColor}">
                    {{strategy.planAmount | formatAmount:'$0,0'}}
                  </div>
                </div>
              </div>
              </div>
              <div class="d-flex savings-info">
                <div class="item pe-3">
                  <div class="heading">Fed Associated Rate</div>
                  <div class="text" [ngStyle]="{'color': selectedThemeColor}">{{strategy.associatedRate}}%</div>
                </div>
                <div class="item pe-3">
                  <div class="heading">Fed Tax Savings</div>
                  <div class="text" [ngStyle]="{'color': selectedThemeColor}">{{strategy.taxSavings | formatAmount:'$0,0'}}</div>
                </div>
                <div class="item pe-3">
                  <div class="heading">State Associated Rate</div>
                  <div class="text" [ngStyle]="{'color': selectedThemeColor}">{{strategy.stateAssociatedRate}}%</div>
                </div>
                <div class="item pe-3">
                  <div class="heading">State Tax Savings</div>
                  <div class="text" [ngStyle]="{'color': selectedThemeColor}">{{strategy.stateTaxSavings | formatAmount:'$0,0'}}</div>
                </div>
              </div>
              <div class="heading mt-3" [ngStyle]="{'border-bottom': '2px solid' + selectedThemeColor, 'padding-bottom': '0.5rem'}">
                <span>GOAL TASK DATE: </span>
                <span>{{strategy.goalDate}}</span>
              </div>
              <div class="mb-3">
                <div class="text mt-2 mb-2">
                  <span class="bold">Fed Associated With: </span>
                  <span>{{strategy.associatedRateName || ''}}</span>
                </div>
                <div class="text mt-2 mb-2">
                  <span class="bold">State Associated With: </span>
                  <span>{{strategy.stateAssociatedRateName || ''}}</span>
                </div>
                <div class="text mt-2 mb-2">
                  <span class="bold">Category: </span>
                  <span>{{strategy.category}}</span>
                </div>
                <div class="text mt-2 mb-2">
                  <span class="bold">Recurring: </span>
                  <span>{{strategy.recurring}}</span>
                </div>
                <div class="text mt-2 mb-2">
                  <span class="bold">Applicable To: </span>
                  <span>{{strategy.applicableTo}}</span>
                </div>
                <div class="text mt-2 mb-2">
                  <span class="bold">Complexity: </span>
                  <span>{{strategy.complexity}}</span>
                </div>
                <div class="text mt-2 mb-2">
                  <span class="bold">Deadline: </span>
                  <span>{{strategy.deadline}}</span>
                </div>
              </div>
              <div>
                <div class="heading" [ngStyle]="{'border-bottom': '2px solid' + selectedThemeColor, 'padding-bottom': '0.5rem'}">ELIGIBILITY CRITERIA:</div>
                <div class="text mt-2" *ngIf="strategy.criteria && strategy.criteria.length > 0">
                  <ul>
                    <li class="word-wrap" *ngFor="let criteria of strategy.criteria">{{criteria.text}}</li>
                  </ul>
                </div>
                <div class="text mt-2 mb-2" *ngIf="strategy.criteria && strategy.criteria.length === 0">
                  No data available.
                </div>
              </div>
              <div>
                <div class="heading" [ngStyle]="{'border-bottom': '2px solid' + selectedThemeColor, 'padding-bottom': '0.5rem'}">CLIENT RESOURCES:</div>
                <div *ngIf="strategy.clientResources" class="text report-strategy-content mt-2 word-wrap" #clientresources id="resource-{{strategy.id}}" [innerHTML]="strategy.clientResources"></div>
                <div *ngIf="!strategy.clientResources" class="text report-strategy-content mt-2 mb-2">No data available.</div>
              </div>
              <div>
                <div class="heading" [ngStyle]="{'border-bottom': '2px solid' + selectedThemeColor, 'padding-bottom': '0.5rem'}">OPPORTUNITIES:</div>
                <div class="text mt-2" *ngIf="strategy.opportunities && strategy.opportunities.length > 0">
                  <ul>
                    <li class="word-wrap" *ngFor="let opportunity of strategy.opportunities">{{opportunity.description}}</li>
                  </ul>
                </div>
                <div class="text mt-2 mb-2" *ngIf="strategy.opportunities && strategy.opportunities.length === 0">
                  No data available.
                </div>
              </div>
              <div>
                <div class="heading" [ngStyle]="{'border-bottom': '2px solid' + selectedThemeColor, 'padding-bottom': '0.5rem'}">RISKS:</div>
                <div class="text mt-2" *ngIf="strategy.potentialRisks && strategy.potentialRisks.length > 0">
                  <ul>
                    <li class="word-wrap" *ngFor="let risk of strategy.potentialRisks">{{risk.description}}</li>
                  </ul>
                </div>
                <div class="text mt-2 mb-2" *ngIf="strategy.potentialRisks && strategy.potentialRisks.length === 0">
                  No data available.
                </div>
              </div>
              <div>
                <div class="heading" [ngStyle]="{'border-bottom': '2px solid' + selectedThemeColor, 'padding-bottom': '0.5rem'}">CLIENT TO DO'S:</div>
                <div class="d-flex flex-wrap mt-2 mb-5" *ngIf="strategy.clientTodos && strategy.clientTodos.length > 0">
                  <div class="text client-todos mt-2 mb-2 pe-3" class="text client-todos mt-2" *ngFor="let todo of strategy.clientTodos;let i=index">
                    <div class="heading"><span>{{todo.name}}</span></div>
                    <div class="text word-wrap" #todotemplate id="todo``{{strategy.id}}``{{todo.id}}" [innerHTML]="todo.description"></div>
                  </div>
                </div>
                <div class="text mt-2 mb-2" *ngIf="strategy.clientTodos && strategy.clientTodos.length === 0">
                  No data available.
                </div>
              </div>
            </div>
            <div class="d-flex mt-2 justify-content-end">
              <div class="logo-on-strategy-page" [ngStyle]="logoBg"></div>
              <div class="d-flex flex-column justify-content-center" style="width: 60%">
                <div [ngStyle]="{'border': '10px solid' + selectedThemeColor}"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </div>

  <div class="customize-report" *ngIf="showReportCustomize" style="width: 20%; border: 1px solid #e9e9e9;border-radius: 5px;padding: 15px;">
    <div class="mb-3 implementation-overview-control" *ngIf="isReportingV2Enabled">
      <label class="io-switch mb-0">
        <input
          type="checkbox"
          [(ngModel)]="overviewStatus"
          (ngModelChange)="onOverviewStatusToggle()"
        />
        <span class="io-slider"></span>
      </label>
      <label class="mb-0 control-text">Show Implementation Overview</label>
    </div>
    <div class="mb-3 implementation-overview-control" *ngIf="isReportingV2Enabled">
      <label class="io-switch mb-0">
        <input
          type="checkbox"
          [(ngModel)]="todoTaskStatus"
          (ngModelChange)="onTodoTaskStatusToggle()"
        />
        <span class="io-slider"></span>
      </label>
      <label class="mb-0 control-text">Show Task and To Dos under each Strategy</label>
    </div>
    <div class="mb-2">
      <label>Theme Color</label>
      <app-color-list *ngIf="hasReset" [pickColorType]="'theme'" [selectedColor]="selectedThemeColor" [themeColors]="themeColorsArray" (onColorSelected)="setCustomizedColor($event)"
                      (onNewColorAdded)="addCustomizedColorToArray($event)"></app-color-list>
    </div>
    <div class="mb-2" *ngIf="isReportingV2Enabled">
      <label>Secondry Theme Color</label>
      <app-color-list *ngIf="hasReset" [pickColorType]="'secondry-theme'" [selectedColor]="selectedThemeSecColor" [secondryThemeColors]="themeColorsSecArray" (onColorSelected)="setCustomizedColor($event)"
                      (onNewColorAdded)="addCustomizedColorToArray($event)"></app-color-list>
    </div>
    <div class="mt-3">
      <label>Text Color</label>
      <app-color-list *ngIf="hasReset" [pickColorType]="'text'" [selectedColor]="selectedTextColor" [textColors]="textColorsArray" (onColorSelected)="setCustomizedColor($event)"
                      (onNewColorAdded)="addCustomizedColorToArray($event)"></app-color-list>
    </div>
    <div class="mt-3">
      <label>Layouts</label>
      <div class="d-flex flex-wrap" *ngIf="!isReportingV2Enabled">
        <div class="pointer layout-image" [ngClass]="{'selected-layout' : selectedThemeName === 'theme1'}" (click)="changeLayout('theme1')">
          <img src="{{layout1Url}}"/>
        </div>
        <div class="pointer layout-image" [ngClass]="{'selected-layout' : selectedThemeName === 'theme2'}" (click)="changeLayout('theme2')">
          <img src="{{layout2Url}}"/>
        </div>
        <div class="pointer layout-image" [ngClass]="{'selected-layout' : selectedThemeName === 'theme3'}" (click)="changeLayout('theme3')">
          <img src="{{layout3Url}}"/>
        </div>
      </div>
      <div class="d-flex flex-wrap" *ngIf="isReportingV2Enabled">
      @for (theme of availableThemes; track theme) {
        <div class="pointer layout-card" 
            [ngClass]="{'selected-layout' : selectedThemeName === theme}"  
            (click)="changeLayout(theme)">
          
          <div class="preview-container" [ngStyle]="theme === 'theme3' ? {
                    'background': 'linear-gradient(0deg, ' 
                      + hexToRgba(selectedThemeColor, 0.1) + ' 30%, ' 
                      + selectedThemeColor + ' 25%)',
                      'height': '100%'
                  } : {}">
            <img [src]="getFullThemePreview(theme)" [alt]="theme" />
          </div>
          
          <div class="theme-label">
            @if (selectedThemeName === theme) {
              <i class="fa fa-check-circle"></i>
            }
          </div>
        </div>
      }
    </div>
    </div>
  </div>
</div>


<div *ngIf="reveal['introLetter']">
  <div class="reveal-overlay" [ngClass]="{'tpiq-reveal': reveal['introLetter']}">
  </div>
  <div class="reveal tax-strategy-reveal" style="padding: 0; border: none; width: 85%;" [ngClass]="{'tpiq-reveal': reveal['introLetter']}">
    <div class="header" style="height: 50px; background-color: #16477a; padding: 15px; color: #fff;">
      <span class="float-left">Introduction</span>
      <span class="float-right pointer" (click)="hideReveal('introLetter')">X</span>
    </div>
    <div class="body" style="padding: 15px;">
      <div class="row">
        <div class="medium-12 columns">
          <label>
            Description :
            <div style="border: 1px solid #cacaca;" [froalaEditor]="editorOptions" [(froalaModel)]="introLetter.description"></div>
          </label>
        </div>
      </div>
      <div class="row">
        <div class="medium-12 columns">
          <button style="margin-top: 10px;" class="button small float-right" [disabled]="readOnly" (click)="saveIntroLetter()">Save</button>
        </div>
      </div>
    </div>
  </div>
</div>
